<style lang="less">
    .color-mask {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1000;
    }
    .palette-fixed {
        z-index: 1000 !important;
    }
    .palette {
        z-index: 1000;
        position: fixed;
        border-radius: 8px;
        padding: 0 0 7px 0;
        width: 241px;
        &.force-windowtype {
            position: relative;
        }
        .activedType {
            .more-color-inner {
                background-color: var(--color-black-6) !important;
            }
        }
        .fixed-win {
            cursor: move;
            height: 28px !important;
            background-color: #e0e0e0;
            margin-top: 0 !important;
            margin-bottom: 4px;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
        }
        .palette-fixicon {
            font-weight: 600;
            display: flex;
            justify-content: space-between;
            align-items: center;
            user-select: none;
            height: 32px;
            width: 100%;
            border-bottom: 1px solid var(--border-color-box-8);
            margin-bottom: 8px;
            span {
                color: var(--text-color-black);
                cursor: default;
                font-size: 13px;
                line-height: 28px;
                margin-left: 16px;
            }
            svg {
                float: right;
                cursor: pointer;
                border-radius: 2px;
                margin-right: 4px;
                display: block;
                width: 24px;
                height: 24px;
                color: var(--svg-color-gray-42);
            }
            .fix-iconbox {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 24px;
                height: 24px;
                margin-right: 4px;
                border-radius: 2px;
                &:hover {
                    background-color: var(--bg-color-float-tool-icon-hover);
                }
            }
            .unFix-icon {
                stroke: #666;
                width: 15px;
                height: 15px;
                &:hover {
                    stroke: black;
                }
            }
            .fix-icon {
                margin: 0;
                width: 16px;
                height: 16px;
            }
        }
        .palette-switch {
            display: flex;
            user-select: none;
            background-color: var(--bg-color-tertiary);
            .actived {
                background-color: var(--bg-color-palette-switch-active) !important;
                font-weight: bold;
            }
            > div {
                width: 50%;
                height: 24px;
                cursor: pointer;
                text-align: center;
                line-height: 24px;
                background-color: var(--bg-color-palette-switch);
                position: relative;
                &:nth-child(1) {
                    border-top-left-radius: 4px;
                    &:not(.actived):hover::after {
                        background: none !important;
                    }
                    &::after {
                        right: -4px;
                        content: "";
                        background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23ffffff' d='M0 0a1 1 0 0 0 1 1H0z'/%3E%3C/svg%3E")
                            no-repeat;
                        width: 4px;
                        height: 4px;
                        position: absolute;
                        bottom: 0;
                        z-index: 1;
                    }
                }
                &:nth-child(2) {
                    border-top-right-radius: 4px;
                    &:not(.actived):hover::before {
                        background: none !important;
                    }
                    &::before {
                        left: -4px;
                        content: "";
                        background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath fill='%23ffffff' d='M0 1A1 1 0 0 0 1 0V1z'/%3E%3C/svg%3E")
                            no-repeat;
                        width: 4px;
                        height: 4px;
                        position: absolute;
                        bottom: 0;
                        z-index: 1;
                    }
                }
                &:hover {
                    background-color: var(--bg-color-float-tool-icon-hover);
                }
            }
        }
        .color-head {
            line-height: 16px;
            padding-bottom: 6px;
            color: var(--text-color-primary);
        }
        .color-series {
            width: 20px;
            margin-right: 1px;
            overflow: visible;
            &:last-child {
                margin-right: unset;
            }
        }
        .reflectColor {
            margin-top: -1px;
            margin-left: -1px;
            margin-right: 0 !important;
            height: 15px !important;
            border: 1px solid gray;
        }
        .color-item {
            cursor: pointer;
            height: 16px;
            width: 20px;
            box-sizing: content-box;
            &.recent-color-item {
                border: 0.5px solid rgba(255, 255, 255, 0.08);
                box-sizing: border-box;
                height: 16px;
                &:hover {
                    box-sizing: content-box;
                }
            }
            &:hover {
                margin-top: -1px;
                margin-left: -1px;
                margin-right: 0 !important;
                height: 15px;
                border: 1px solid gray;
            }
        }
        .alpha-panel {
            margin-bottom: 8px;
            padding: 0 16px;
            .alpha-head {
                margin-bottom: 4px;
            }
            .alpha-slider-box {
                height: 24px;
                display: flex;
                // justify-content: space-between;
                align-items: center;
                .ivu-slider {
                    flex: 1;
                    margin-right: 32px;
                }
                .ivu-input-number-handler-wrap,
                .ivu-input-number-input {
                    background-color: var(--bg-color-tertiary);
                }
            }
        }
        .recent-panel {
            margin-bottom: 16px;
            padding: 0 16px;
            .recent-colors {
                display: flex;
                > div {
                    margin-right: 1px;
                    overflow: visible;
                }
                height: 16px;
            }
        }
        .theme-panel {
            display: flex;
            // background-color: var(--bg-color-palette-theme-panel);
            padding: 0 16px;
        }
        .standard-panel {
            margin-top: 8px;
            margin-bottom: 8px;
            padding: 0 16px;
            .standard-colors {
                display: flex;
                > div {
                    margin-right: 1px;
                    overflow: visible;
                }
            }
        }
        // .more-color-panel{
        //     display: flex;
        //     justify-content: space-between;
        //     >div{
        //         border-radius: 3px;
        //     }
        // }
        .more-color {
            cursor: pointer;
            padding: 0 6px;
            .more-color-inner {
                display: flex;
                padding: 6px 10px;
                line-height: 16px;
                align-items: center;
                border-radius: 6px;
                &:hover {
                    background: var(--bg-color-float-tool-icon-hover) !important;
                }
                .no-fill {
                    stroke: var(--svg-color-no-fill-stroke);
                    fill: var(--svg-color-no-fill-fill);
                }
                > span {
                    display: inline-block;
                    min-width: 48px;
                    pointer-events: none;
                    // cursor: default;
                }
                > svg {
                    width: 20px;
                    height: 16px;
                    margin-left: 6px;
                    color: var(--svg-color-gray-42);
                }
                > img {
                    display: block;
                    margin-left: 6px;
                }
            }
        }
        .color-linebox-line {
            border-top: 1px solid var(--border-color-palette-fix-icon);
            width: calc(100% - 32px);
            margin: 4px 0 8px 16px;
        }
        .color-linebox {
            &.more-setting {
                padding: 0 6px;
            }
            .palette-divider {
                height: 1px;
                background-color: var(--border-color-palette-fix-icon);
                width: 88%;
                margin: 4px auto;
            }
            .color-linebox-text {
                padding: 5px 10px;
                border-radius: 6px;
                &:hover {
                    background-color: var(--bg-color-float-tool-icon-hover);
                }
            }
            .expand-item {
                &:after {
                    content: "";
                    margin-left: auto;
                    margin-top: 9px;
                    display: block;
                    position: absolute;
                    right: 16px;
                    top: 2px;
                    width: 0;
                    height: 0;
                    border-top: 3px solid transparent;
                    border-bottom: 3px solid transparent;
                    border-left: 3px solid #757575;
                }
            }
            .color-linebox-hoverbox {
                position: relative;
                height: 28px;
                margin: 0 6px;
                p {
                    padding: 5px 16px;
                    padding-left: 46px;
                    border-radius: 6px;
                    &:hover {
                        background-color: var(--bg-color-float-tool-icon-hover);
                    }
                }
                .item-icon {
                    position: absolute;
                    left: 16px;
                    top: 2px;
                    width: 24px;
                    height: 24px;
                    &:focus {
                        outline: none;
                    }
                }
                ul {
                    display: none;
                    position: absolute;
                    list-style: none;
                    left: 100%;
                    top: 0;
                    width: 135px;
                    background-color: #fff;
                    max-height: 400px;
                    overflow-y: auto;
                    box-shadow: 0 1px 6px var(--color-black-20);
                    padding: 6px;
                    border-radius: 6px;
                    li {
                        display: flex;
                        align-items: center;
                        padding: 5px 16px;
                        border-radius: 6px;
                        &.actived,
                        &:hover {
                            background-color: var(--bg-color-float-tool-icon-hover);
                        }
                        .item-icon {
                            width: 80px;
                            height: 18px;
                        }
                        .line-num {
                            margin-left: 6px;
                            font-size: 12px;
                            color: #222;
                            padding: 0;
                            user-select: none;
                            cursor: pointer;
                        }
                    }
                    .splice-line {
                        width: 80%;
                        height: 1px;
                        margin: 0 auto;
                        background: rgba(0, 0, 0, 0.06);
                    }
                    .expand-item-jump {
                        position: relative;
                        display: flex;
                        padding-left: 36px;
                        img {
                            position: absolute;
                            left: 10px;
                            top: 2px;
                            width: 24px;
                            height: 24px;
                        }
                        svg {
                            position: absolute;
                            left: 10px;
                            top: 2px;
                            width: 24px;
                            height: 24px;
                            color: #424242;
                            &:focus {
                                outline: none;
                            }
                        }
                        span {
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            width: 100%;
                        }
                    }
                }
                &.hover {
                    ul {
                        display: block;
                    }
                    .expand-item-flat {
                        display: flex;
                    }
                }
                .expand-item-lineweight {
                    li {
                        display: flex;
                        align-items: center;
                        div {
                            width: 45px;
                            margin-right: 5px;
                            background: #000;
                        }
                    }
                }
                // 两排平铺布局
                .expand-item-flat {
                    display: none;
                    padding: 6px;
                    flex-wrap: wrap;
                    justify-content: center;
                    li {
                        padding: 4px;
                        margin: 2px;
                        border-radius: 6px;
                        max-height: 48px;
                        .item-icon {
                            margin-left: 0;
                            border: 1px solid var(--border-color-float-hv-line);
                            border-radius: 6px;
                            width: 40px;
                            height: 40px;
                        }
                    }
                }
                .list-align {
                    display: flex;
                    justify-content: space-between;
                    align-content: center;
                }
            }
        }
    }
</style>
<style lang="stylus">
    .palette
        background-color var(--bg-color-palette)
        box-shadow $box-shadow
        padding-bottom: 8px;
        &.iconfont-palette
            padding-top 6px;
        &.hide-alpha
            // padding: 6px;


        .color-linebox

            .ft-menu,.ft-submenu
                height 28px
            .ft-submenu
                padding 0 6px;
            .ft-menu
                padding-left 10px;
                .ft-menuicon
                    margin-left 0
            .palette--expand
                min-width 92px
                height 208px
                background $ft-bgcolor
                padding 6px
                border-radius $ft-boxradius
                overflow overlay

                .splice-line
                    width 80%
                    height 1px
                    margin 0 auto
                    background rgba(0, 0, 0, 0.06)

                li
                    position relative
                    border-radius 6px
                    display flex
                    align-items center
                    padding 10px
                    height 28px
                    white-space nowrap
                    &.expand-item-jump
                        .item-icon
                            width: 24px;
                            height: 24px;
                            color: var(--svg-color-gray-42);
                            &:focus
                                outline: none;

                    div
                        width 45px
                        margin-right: 5px
                        background var(--bg-color-black)

                    .item-icon
                        width 80px
                        height 18px
                        color: var(--svg-color-black);
                        &:focus
                            outline: none;
                    .line-num
                        margin-left 6px
                        font-size 12px
                        color var(--text-color-primary);
                        padding 0
                        user-select none
                        cursor pointer

                    &:not(.active):hover
                        background $ft-hover

                    &.active
                        background $ft-active

            .expand-item-flat
                display flex
                flex-wrap wrap
                justify-content center
                background $ft-bgcolor
                padding 6px
                border-radius $ft-boxradius
                list-style none
                li
                    padding 4px
                    margin 2px
                    border-radius 6px
                    max-height 48px
                    .item-icon
                        margin-left 0
                        border 1px solid var(--border-color-float-hv-line)
                        border-radius 6px
                        width 40px
                        height 40px
                        color: var(--svg-color-gray-42-secondary)
                        &:focus
                                outline: none
        .ivu-slider:not(.ivu-slider-disabled) .ivu-slider-button
            border-color #57a3f3
</style>
<i18n>
{
  "zh": {
    "fillColor": "填充颜色",
    "lineColor": "线条颜色",
    "fontColor": "字体颜色",
    "fontbgColor": "背景色",
    "Color": "颜色",
    "QuickStyle": "快速样式",
    "RecentColors": "最近使用颜色",
    "transparency": "透明度",
    "StandardColors": "标准颜色",
    "MoreColors": "更多颜色",
    "colorPicker": "取色器",
    "NoFill": "无填充",
    "NoBorder": "无边框",
    "MoreSetting": "更多填充设置",
    "MoreLine": "更多线条设置",
    "lineSize": "粗细",
    "lineType": "虚线",
    "lineArrow": "箭头",
    "otherWeight": "其他粗细",
    "otherStyle": "其他虚线",
    "otherArrow": "其他箭头",
    "shapeRadius": "圆角",
    "branchStyle": "样式",
    "fixTip": "点击图钉按钮可以固定您的菜单。"
  },
  "en": {
    "fillColor": "Fill",
    "lineColor": "Line Fill",
    "fontColor": "Text Fill",
    "fontbgColor": "Text Highlight Color",
    "Color": "Color",
    "QuickStyle": "Quick Styles",
    "RecentColors": "Recent Colors",
    "transparency": "Transparency",
    "StandardColors": "Standard Colors",
    "MoreColors": "More Colors",
    "colorPicker": "Eyedropper",
    "NoFill": "No Fill",
    "NoBorder": "No Border",
    "MoreSetting": "More Fill Settings",
    "MoreLine": "Line Options...",
    "lineSize": "Line Weight",
    "lineType": "Line Type",
    "lineArrow": "Arrow",
    "otherWeight": "More Lineweights",
    "otherStyle": "More Linetypes",
    "otherArrow": "More Arrows",
    "shapeRadius": "Shape Radius",
    "branchStyle": "Line Styles",
    "fixTip": "Click the Pushpin button to fix your menu."
  },
  "fr": {
    "fillColor": "Couleur de remplissage",
    "lineColor": "Couleur de ligne",
    "fontColor": "couleur de police",
    "fontbgColor": "Couleur de fond",
    "Color": "Couleur",
    "QuickStyle": "Style Rapide",
    "RecentColors": "Couleurs Récentes",
    "transparency": "Transparence",
    "StandardColors": "Couleurs Standard",
    "MoreColors": "Plus Couleurs",
    "colorPicker": "Prélever une couleur",
    "NoFill": "Aucun Remplissage",
    "NoBorder": "Pas de Frontière",
    "MoreSetting": "Plus de paramètres de remplissage",
    "MoreLine": "Plus de paramètres de pinceau.",
    "lineSize": "Epaisseur de la ligne",
    "lineType": "Type de ligne",
    "lineArrow": "Flèche",
    "otherWeight": "Plus d'épaisseurs de ligne",
    "otherStyle": "Plus de types de lignes",
    "otherArrow": "Plus de Flèches",
    "shapeRadius": "Filet",
    "branchStyle": "Styles de ligne",
    "fixTip": "Cliquez sur le bouton Punaise pour corriger votre menu."
  },

  "de": {
    "fillColor": "Füllfarbe",
    "lineColor": "Linienfarbe",
    "fontColor": "Schriftfarbe",
    "fontbgColor": "Hintergrundfarbe",
    "Color": "Farbe",
    "QuickStyle": "QuickStyle",
    "RecentColors": "Aktuelle Farben",
    "transparency": "Transparent",
    "StandardColors": "Standardfarben",
    "MoreColors": "Weitere Farben",
    "colorPicker": "Pipette",
    "NoFill": "Keine Füllung",
    "NoBorder": "Kein Rahmen",
    "MoreSetting": "Weitere Fülleinstellungen",
    "MoreLine": "Weitere Kontureinstellungen",
    "lineSize": "Linienstärke",
    "lineType": "Linientyp",
    "lineArrow": "Pfeil",
    "otherWeight": "Weitere Linienstärken",
    "otherStyle": "Mehr Linientypen",
    "otherArrow": "Weitere Pfeile",
    "shapeRadius": "Abgerundete Ecke",
    "branchStyle": "Linienstile",
    "fixTip": "Klicken Sie auf die Reißzwecke, um Ihr Menü zu korrigieren."
  },
  "jp": {
    "fillColor": "塗りつぶしの色",
    "lineColor": "線の色",
    "fontColor": "フォントの色",
    "fontbgColor": "テキストの背景色",
    "Color": "色",
    "QuickStyle": "クイックスタイル",
    "RecentColors": "最近使った色",
    "transparency": "透明度",
    "StandardColors": "標準色",
    "MoreColors": "その他の色",
    "colorPicker": "スポイト",
    "NoFill": "塗りつぶしなし",
    "NoBorder": "線なし",
    "MoreSetting": "その他の塗りつぶし設定",
    "MoreLine": "その他のストローク設定",
    "lineSize": "太さ",
    "lineType": "線種",
    "lineArrow": "矢印",
    "otherWeight": "その他の線",
    "otherStyle": "その他の線",
    "otherArrow": "その他の矢印",
    "shapeRadius": "フィレット",
    "branchStyle": "線のスタイル",
    "fixTip": "プッシュピンボタンをクリックしてメニューを固定します。"
  },
  "es": {
    "fillColor": "Rellenar color",
    "lineColor": "Color de linea",
    "fontColor": "Color de fuente",
    "fontbgColor": "Color de resalte del texto",
    "Color": "Colores",
    "QuickStyle": "Estilo rápido",
    "RecentColors": "Colores recientes",
    "transparency": "Transparencia",
    "StandardColors": "Colores estándar",
    "MoreColors": "Más colores",
    "colorPicker": "Cuentagotas",
    "NoFill": "No llenar",
    "NoBorder": "Sin Fronteras",
    "MoreSetting": "Más ajustes de relleno",
    "MoreLine": "Más ajustes de trazo",
    "lineSize": "Grosor de la línea",
    "lineType": "Tipo de Línea",
    "lineArrow": "Flecha",
    "otherWeight": "Más Grosores de Línea",
    "otherStyle": "Más Tipos de Líneas",
    "otherArrow": "Más Flechas",
    "shapeRadius": "Radio angular",
    "branchStyle": "Estilos de Línea",
    "fixTip": "Haz clic en el botón Chincheta para arreglar su menú."
  },
  "pt": {
    "fillColor": "Cor de Preenchimento",
    "lineColor": "Cor da Linha",
    "fontColor": "Cor da Fonte",
    "fontbgColor": "Cor do Destaque de Texto",
    "Color": "Cor",
    "QuickStyle": "Estilo Rápido",
    "RecentColors": "Cores Recentes",
    "transparency": "Transparência",
    "StandardColors": "Cores Padrão",
    "MoreColors": "Mais Cores",
    "colorPicker": "Conta-gotas",
    "NoFill": "Sem Preenchimento",
    "NoBorder": "Sem Margem",
    "MoreSetting": "Mais configurações de preenchimento",
    "MoreLine": "Mais configurações de traçado",
    "lineSize": "Espessura da Linha",
    "lineType": "Tipo de Linha",
    "lineArrow": "Seta",
    "otherWeight": "Mais espessuras de linha",
    "otherStyle": "Mais Tipos de Linha",
    "otherArrow": "Mais setas",
    "shapeRadius": "Forma de Raio",
    "branchStyle": "Estilos de linha",
    "fixTip": "Clique no botão Pushpin para fixar seu menu."
  },
  "it": {
    "fillColor": "Colore di riempimento",
    "lineColor": "Colore di linea",
    "fontColor": "Colore del carattere",
    "fontbgColor": "Colore di Evidenziazione",
    "Color": "Colore",
    "QuickStyle": "StileRapido",
    "RecentColors": "Colori Recenti",
    "transparency": "Trasparenza",
    "StandardColors": "Colori Standard",
    "MoreColors": "Altri Colori",
    "colorPicker": "Contagocce",
    "NoFill": "Nessun Riempimento",
    "NoBorder": "Nessun Bordo",
    "MoreSetting": "Altre impostazioni riempimento",
    "MoreLine": "Altre impostazioni tratto",
    "lineSize": "Spessore della linea",
    "lineType": "Tipo di linea",
    "lineArrow": "Freccia",
    "otherWeight": "Più Pesi di Linea",
    "otherStyle": "Più Tipi di Linea",
    "otherArrow": "Più Frecce",
    "shapeRadius": "forma raggio",
    "branchStyle": "Stili di Linea",
    "fixTip": "Fare clic sul pulsante Puntina da disegno per correggere il menu."
  },
  "tw": {
    "fillColor": "填充顏色",
    "lineColor": "線條顏色",
    "fontColor": "字體顏色",
    "Color": "顏色",
    "QuickStyle": "快速樣式",
    "RecentColors": "最近使用顏色",
    "transparency": "透明度",
    "StandardColors": "標準顏色",
    "MoreColors": "更多顏色",
    "colorPicker": "取色器",
    "NoFill": "無填充",
    "NoBorder": "無邊框",
    "MoreSetting": "填充選項...",
    "MoreLine": "線條選項...",
    "lineSize": "粗細",
    "lineType": "虛線",
    "lineArrow": "箭頭",
    "otherWeight": "其他粗細",
    "otherStyle": "其他虛線",
    "otherArrow": "其他箭頭",
    "shapeRadius": "圓角",
    "branchStyle": "樣式",
    "fixTip": "單擊圖釘按鈕可以固定您的菜單。"
  }
}
</i18n>
<template>
    <div @mousedown="changeClickPropagation($event)">
        <div class="color-mask" v-show="useMask && type && showPalette && !fixed" @click="closeThis($event)"></div>
        <div
            class="palette"
            v-show="fixed ? type : type && showPalette && !forceShowPalette"
            ref="pal"
            :class="{ 'palette-fixed': fixed, 'force-windowtype': force, 'hide-alpha': !showAlpha, [`${this.type}-palette`]: true }"
            :style="{
                top: force ? 'unset' : (fixed ? fixTop : paletteInfo.top) + 'px',
                left: force ? 'unset' : (fixed ? fixLeft : paletteInfo.left) + 'px',
            }"
        >
            <div class="palette-fixicon" v-show="couldFix || fixed" @mousedown="startDrag" :class="{ 'fixed-win': fixed }">
                <span>{{ $t(type) }}</span>
                <div class="fix-iconbox" ref="fixBtn">
                    <iconSymbol v-if="fixed" @click.native="toCloseFix" class="unFix-icon" name="Del" />
                    <iconSymbol v-else @click.native="toFix" class="fix-icon" name="lockNail" />
                </div>
            </div>
            <div class="palette-switch" v-if="type && type.startsWith('ChildFillColor')">
                <div @mousedown.stop="changeTyoe(0)" :class="{ actived: showType === 0 }">{{ $t("Color") }}</div>
                <div @mousedown.stop="changeTyoe(1)" :class="{ actived: showType === 1 }">{{ $t("QuickStyle") }}</div>
            </div>
            <div
                v-if="!showType"
                class="palette-content"
                :style="{
                    marginTop: fixed || couldFix || force ? '0px' : type && type.startsWith('ChildFillColor') ? '8px' : '15px',
                }"
            >
                <div class="alpha-panel" @mousedown.stop v-show="showAlpha">
                    <div class="alpha-head">{{ $t("transparency") }}</div>
                    <div class="alpha-slider-box" @mousedown.stop>
                        <Slider
                            :max="100"
                            :min="0"
                            v-model="alphaVal"
                            :disabled="alphaValDisabed"
                            @on-input="changeAlpha()"
                            @mousedown.native="modifyTintPreRedo()"
                            @mouseup.native="modifyTintRedo()"
                        ></Slider>
                        <InputNumber
                            class="input-num"
                            :max="100"
                            :min="0"
                            style="width: 64px"
                            size="small"
                            v-model="alphaVal"
                            :active-change="false"
                            :formatter="(value) => `${value}%`"
                            :parser="(value) => value.replace('%', '')"
                            :disabled="alphaValDisabed"
                            @on-focus="editLocker('focus', 'inputLocker')"
                            @on-blur="
                                editLocker('blur', 'inputLocker', () => {
                                    changeAlpha();
                                })
                            "
                            @on-change="
                                editLocker('edit', 'inputLocker', () => {
                                    changeAlpha();
                                })
                            "
                            @keyup.enter.native="iviewInputBlur($event)"
                        ></InputNumber>
                    </div>
                </div>
                <div class="recent-panel" v-show="recentColorsLen">
                    <div class="color-head">{{ $t("RecentColors") }}</div>
                    <div class="recent-colors">
                        <div
                            class="color-item"
                            :key="item"
                            v-for="item in recentClickColors"
                            :style="{ 'background-color': item }"
                            :class="{ 'recent-color-item': isDarkTheme() }"
                            @mousedown="clickColor($event, item, undefined, undefined)"
                            @mouseover="mouseoverColor($event, item)"
                            @mouseleave="mouseleaveColor()"
                        ></div>
                    </div>
                </div>
                <div class="theme-panel">
                    <div class="color-series" v-for="(colors, col) in themeColor" :key="colors.id">
                        <div
                            class="color-item"
                            v-for="(item, index) in colors"
                            :style="{ 'background-color': item }"
                            :class="{ reflectColor: item === currentColor }"
                            :key="item.id"
                            @mousedown="clickColor($event, item, col, index)"
                            @mouseover="mouseoverColor($event, item)"
                            @mouseleave="mouseleaveColor()"
                        ></div>
                    </div>
                </div>
                <div class="standard-panel">
                    <div class="color-head">{{ $t("StandardColors") }}</div>
                    <div class="standard-colors">
                        <div
                            class="color-item"
                            v-for="item in standardColors"
                            :style="{ 'background-color': item }"
                            :class="{ reflectColor: item === currentColor }"
                            :key="item"
                            @mousedown="clickColor($event, item, undefined, undefined)"
                            @mouseover="mouseoverColor($event, item)"
                            @mouseleave="mouseleaveColor()"
                        ></div>
                    </div>
                </div>
                <div class="color-head more-color" @mousedown.stop="toggleModal">
                    <div class="more-color-inner">
                        <span>{{ $t("MoreColors") }}</span>
                        <img :src="require('@/app/assets/img/addition/moreColor.png')" />
                    </div>
                </div>
                <div class="color-head more-color" @mousedown.stop @click="toShowColorSucker">
                    <div class="more-color-inner">
                        <span>{{ $t("colorPicker") }}</span>
                        <iconSymbol name="colorSuckerIcon" />
                    </div>
                </div>
                <div
                    v-if="
                        (['fillColor', 'branchFill', 'fontbgColor', 'mmFill', 'echartBgColor'].includes(type) ||
                            (type == 'fontColor' && colorIndex) ||
                            type == 'defaultFontbg') &&
                        showNoFill
                    "
                    class="color-head more-color"
                    :class="{ activedType: !fillFmtType }"
                    @mousedown="noFill"
                    @mouseenter="startPreviewNofill"
                    @mouseleave="endPreviewNofill"
                >
                    <div class="more-color-inner">
                        <span>{{ $t("NoFill") }}</span>
                        <iconSymbol class="no-fill" :name="'noFillColor'" />
                    </div>
                </div>
                <template v-if="type == 'fillColor' && showMore">
                    <div class="color-linebox-line"></div>
                    <div class="color-head more-color" @mousedown="moreColorSetting">
                        <div class="more-color-inner">
                            <span>{{ $t("MoreSetting") }}</span>
                        </div>
                    </div>
                </template>
                <div
                    class="color-linebox"
                    v-if="!hideLineExtra.includes('noBorder') && ['lineColor', 'branchLine', 'mmLine', 'RightColorLine'].includes(type)"
                    @mousedown.stop
                    @click.stop
                >
                    <div
                        class="more-color"
                        :class="{ activedType: !lineFmtType }"
                        @mousedown="noLine"
                        @mouseenter="startPreviewNofill"
                        @mouseleave="endPreviewNofill"
                    >
                        <div class="more-color-inner">
                            <span>{{ $t("NoBorder") }}</span>
                            <iconSymbol class="no-fill" :name="'noFillColor'" />
                        </div>
                    </div>
                    <!-- 思维导图线条共用部分选项，通过 hideLineExtra 数组和 showMore 参数配置 -->
                    <template v-if="force && ['lineColor', 'mmLine'].includes(windowType)">
                        <div
                            class="palette-divider"
                            v-if="
                                !hideLineExtra.includes('lineType') ||
                                !hideLineExtra.includes('lineType') ||
                                !hideLineExtra.includes('lineArrow') ||
                                !hideLineExtra.includes('radius')
                            "
                        ></div>
                        <FTSubMenu
                            v-if="!hideLineExtra.includes('lineSize')"
                            :imgIcon="'float-lineweight'"
                            :text="$t('lineSize')"
                            :isExpand="true"
                            :disable="!isSelect"
                        >
                            <template #content>
                                <ul class="palette--expand">
                                    <li
                                        v-for="(item, index) in lineSize"
                                        :key="index"
                                        @click="selectLineSize(index, item.value)"
                                        @mouseenter="startPreview('lineSize', item.value)"
                                        @mouseleave="endPreview"
                                    >
                                        <div :style="{ height: `${item.value}px` }"></div>
                                        {{ item.label + " pt" }}
                                    </li>
                                    <template v-if="showMore">
                                        <div class="splice-line"></div>
                                        <li class="expand-item-jump" @click="moreLineSetting">
                                            <iconSymbol class="item-icon" name="float-lineweight" />
                                            <span :title="$t('otherWeight')">{{ $t("otherWeight") }}</span>
                                        </li>
                                    </template>
                                </ul>
                            </template>
                        </FTSubMenu>
                        <FTSubMenu
                            v-if="!hideLineExtra.includes('lineType')"
                            :imgIcon="'float-linestyle'"
                            :text="$t('lineType')"
                            :isExpand="true"
                            :disable="!isSelect"
                        >
                            <template #content>
                                <ul class="palette--expand">
                                    <template v-if="fromFloatTool">
                                        <li
                                            v-for="item in 10"
                                            :key="item"
                                            @click="selectLineStyle(item)"
                                            @mouseenter="startPreview('lineType', item)"
                                            @mouseleave="endPreview"
                                        >
                                            <iconSymbol class="item-icon" :name="activeDashTypeUrl(item - 1)" />
                                            <p class="line-num">{{ addZero(item - 1) }}</p>
                                        </li>
                                    </template>
                                    <template v-else>
                                        <li
                                            v-for="item in 23"
                                            :key="item"
                                            @click="selectLineStyle(item)"
                                            @mouseenter="startPreview('lineType', item)"
                                            @mouseleave="endPreview"
                                        >
                                            <iconSymbol class="item-icon" :name="activeDashTypeUrl(item - 1)" />
                                            <p class="line-num">{{ addZero(item - 1) }}</p>
                                        </li>
                                    </template>
                                    <template v-if="showMore">
                                        <div class="splice-line"></div>
                                        <li class="expand-item-jump" @click="moreLineSetting">
                                            <iconSymbol class="item-icon" name="float-linestyle" />
                                            <span :title="$t('otherStyle')">{{ $t("otherStyle") }}</span>
                                        </li>
                                    </template>
                                </ul>
                            </template>
                        </FTSubMenu>
                        <!-- <FTSubMenu
                            v-if="!hideLineExtra.includes('lineArrow')"
                            :imgIcon="'float-fillcolor-arrow'"
                            :text="$t('lineArrow')"
                            :isExpand="true"
                            :disable="!isSelect"
                        >
                            <template #content>
                                <ul class="palette--expand">
                                    <template v-if="fromFloatTool">
                                        <li
                                            v-for="item in floatToolArrowList"
                                            :key="item.id"
                                            @click="selectFloatArrow(item.type, item.value)"
                                            @mouseenter="startPreview('arrowType', item)"
                                            @mouseleave="endPreview"
                                        >
                                            <iconSymbol
                                                :style="item.type == 1 ? 'transform: rotate(180deg)' : ''"
                                                class="item-icon"
                                                :name="item.icon"
                                            />
                                        </li>
                                    </template>
                                    <template v-else>
                                        <li
                                            v-for="item in 50"
                                            :key="item"
                                            @click="selectArrowL(item)"
                                            @mouseenter="startPreview('arrowType', { type: 0, value: item })"
                                            @mouseleave="endPreview"
                                        >
                                            <iconSymbol style="transform: rotate(180deg)" class="item-icon" :name="activeBeginTypeUrl(item - 1)" />
                                        </li>
                                        <li
                                            v-for="item in 50"
                                            :key="item + 50"
                                            @click="selectArrowR(item)"
                                            @mouseenter="startPreview('arrowType', { type: 1, value: item })"
                                            @mouseleave="endPreview"
                                        >
                                            <iconSymbol class="item-icon" :name="activeEndTypeUrl(item - 1)" />
                                        </li>
                                    </template>
                                    <template v-if="showMore">
                                        <div class="splice-line"></div>
                                        <li class="expand-item-jump" @click="moreLineSetting">
                                            <iconSymbol class="item-icon" name="float-fillcolor-arrow" />
                                            <span :title="$t('otherArrow')">{{ $t("otherArrow") }}</span>
                                        </li>
                                    </template>
                                </ul>
                            </template>
                        </FTSubMenu> -->
                        <FTSubMenu
                            v-if="!hideLineExtra.includes('radius')"
                            :imgIcon="'float-fillcolor-radius'"
                            :text="$t('shapeRadius')"
                            :isExpand="true"
                            :disable="!isSelect"
                        >
                            <template #content>
                                <ul class="expand-item-flat" style="width: 220px">
                                    <li :class="{ active: item - 1 == activeRPType }" v-for="item in 8" :key="item" @click="selectRadius(item - 1)">
                                        <iconSymbol class="item-icon" :name="`mm-radiuslist-0${item}`" />
                                    </li>
                                </ul>
                            </template>
                        </FTSubMenu>
                    </template>
                    <!-- 思维导图分支线条扩展选项 -->
                    <template v-else-if="force && windowType == 'branchLine'">
                        <div class="palette-divider"></div>
                        <FTSubMenu :imgIcon="'float-lineweight'" :text="$t('lineSize')" :isExpand="true" :disable="!isSelect">
                            <template #content>
                                <ul class="palette--expand">
                                    <li
                                        v-for="(item, index) in lineSize"
                                        :key="index"
                                        @click="selectBranchItem('lineWidth', { height: item.value })"
                                        @mouseenter="selectBranchItem('lineWidth', { height: item.value }, true)"
                                        @mouseleave="cancelPreview"
                                    >
                                        <div :style="{ height: `${item.value}px` }"></div>
                                        {{ item.label + " pt" }}
                                    </li>
                                </ul>
                            </template>
                        </FTSubMenu>
                        <FTSubMenu :imgIcon="'float-linestyle'" :text="$t('lineType')" :isExpand="true" :disable="!isSelect">
                            <template #content>
                                <ul class="palette--expand">
                                    <li
                                        v-for="(line, index) in 9"
                                        :key="line"
                                        @click="selectBranchItem('dottedLine', { lineType: line })"
                                        @mouseenter="selectBranchItem('dottedLine', { lineType: line }, true)"
                                        @mouseleave="cancelPreview"
                                        class="list-align"
                                    >
                                        <iconSymbol class="item-icon" :name="`dt${index}`" />
                                        <span>{{ line < 10 ? "0" + line : line }}</span>
                                    </li>
                                </ul>
                            </template>
                        </FTSubMenu>
                        <!-- <FTSubMenu :imgIcon="'branch-line-style'" :text="$t('branchStyle')" :isExpand="true" :disable="!isSelect">
                            <template #content>
                                <ul class="expand-item-flat" style="width: 180px">
                                    <li
                                        v-for="thickness in 6"
                                        :key="thickness"
                                        @click="
                                            selectBranchItem('branchThickness', {
                                                thickness: thickness - 1,
                                            })
                                        "
                                        @mouseenter="selectBranchItem('branchThickness', { thickness: thickness - 1 }, true)"
                                        @mouseleave="cancelPreview"
                                    >
                                        <iconSymbol class="item-icon" :name="`mm-thickness-0${thickness}`" />
                                    </li>
                                </ul>
                            </template>
                        </FTSubMenu> -->
                        <FTSubMenu
                            v-if="!hideLineExtra.includes('radius')"
                            :imgIcon="'float-fillcolor-arrow'"
                            :text="$t('lineArrow')"
                            :isExpand="true"
                            :disable="!isSelect"
                        >
                            <template #content>
                                <ul class="palette--expand">
                                    <li
                                        v-for="arrow in branchArrowList"
                                        :key="arrow"
                                        @click="selectBranchItem('branchArrow', { arrowType: arrow })"
                                        @mouseenter="selectBranchItem('branchArrow', { arrowType: arrow }, true)"
                                        @mouseleave="cancelPreview"
                                    >
                                        <iconSymbol class="item-icon" :name="`arrow-${arrow}`" />
                                    </li>
                                </ul>
                            </template>
                        </FTSubMenu>
                    </template>
                </div>
                <template v-if="['lineColor', 'branchLine', 'mmLine'].includes(type) && showMore">
                    <div class="color-linebox-line"></div>
                    <div class="color-linebox more-setting">
                        <p class="color-linebox-text" @mousedown="moreLineSetting">
                            {{ $t("MoreLine") }}
                        </p>
                    </div>
                </template>
            </div>
            <QuickStyleBox v-else :type="'Single'" style="margin-top: 8px"></QuickStyleBox>
            <EDNotice
                v-if="useFixTips && couldFix"
                :show="showFixTips"
                :dom="fixTipsDom"
                :forceDirect="'left'"
                :content="$t('fixTip')"
                @closeTips="closeFixTips"
            />
        </div>
    </div>
</template>

<script lang="ts">
    declare var EDColorUtil: any;
    declare var EDColor: any;
    declare var EDChart: any;
    declare var EDEChartItem: any;
    declare var eFmtSetFlag: any;
    declare var EDOpeAssist: any;
    declare var eMsgType: any;
    import Sketch from "../Sketch/Sketch.vue";
    import QuickStyleBox from "../../Modals/QuickStyleBox.vue";
    import { Component, Prop, Vue, Watch, Inject, Mixins } from "vue-property-decorator";
    import FTSubMenu from "@/app/components/FloatTool/public/FTSubMenu.vue";
    import EDNotice from "@/app/components/Notice/EDNotice.vue";
    import ExpandRightPanel from "../../FloatTool/ExpandRightPanel";

    @Component({
        components: {
            Sketch,
            QuickStyleBox,
            FTSubMenu,
            EDNotice,
        },
    })
    export default class Palette extends Mixins(ExpandRightPanel) {
        @Inject()
        ["iviewInputBlur"];

        @Prop({ default: false }) readonly fixed: boolean; //是否是固定窗口
        @Prop({ default: "" }) readonly windowType: string; // 固定窗口类型
        @Prop({ default: false }) readonly force: boolean; // 强制设置窗口类型
        @Prop({ default: -1 }) readonly forceIndex: number; // 强制设置窗口类型
        @Prop({ default: true }) readonly useMask: boolean; // 是否启用mask
        @Prop({ default: true }) readonly showMore: boolean; // 是否展示更多设置
        @Prop({ default: "" }) from: string; // 引入源
        @Prop({ default: "" }) pluginColor: string; // 当前选中的颜色
        // 隐藏填充线条的扩展选项（不包含思维导图的分支线条）
        @Prop({ default: () => [] }) readonly hideLineExtra: Array<string>;
        fixTop = 0;
        fixLeft = 0;
        showType: number = 0; // 0 for default palette, 1 for quick style.
        showModal: boolean = false;
        recentColors: Array<string> = [];
        activeExtra: string = "";
        lineSize = [
            {
                value: 0.25,
                label: "0.25",
            },
            {
                value: 0.75,
                label: "0.75",
            },
            {
                value: 1,
                label: "1.00",
            },
            {
                value: 1.5,
                label: "1.50",
            },
            {
                value: 2,
                label: "2.00",
            },
            {
                value: 3,
                label: "3.00",
            },
            {
                value: 4,
                label: "4.00",
            },
            {
                value: 5,
                label: "5.00",
            },
            {
                value: 6,
                label: "6.00",
            },
        ];
        branchArrowList: Array<number> = [0, 3, 4, 11, 5, 12, 6, 13, 19, 18, 30, 22, 31];
        standardColors = ["#c00000", "#ff0000", "#ffc000", "#ffff00", "#92d050", "#00b050", "#00b0f0", "#0070c0", "#002060", "#7030a0"];

        get forceShowPalette() {
            return this.force && (this.$store.state.ui.showColorSucker || this.$store.state.dialog.showSketch);
        }
        toShowColorSucker() {
            this.$store.commit("setStatus", {
                type: "showColorSucker",
                data: true,
            });
            if (this.fixed || this.force) {
                this.$store.commit("setDialogState", {
                    type: "sketchType",
                    data: this.type,
                });
            }
            this.showPalette = false;
        }
        addZero(str) {
            return (str + "").padStart(2, "0");
        }

        toggleModal() {
            this.showPalette = false;
            const timer = this.force ? 200 : 0;
            setTimeout(() => {
                // 防止force模式下异常触发document，导致color窗口关闭
                this.$store.commit("setDialogState", {
                    type: "showSketch",
                    data: true,
                });
                if (this.fixed || this.force) {
                    this.$store.commit("setDialogState", {
                        type: "sketchType",
                        data: this.type,
                    });
                }
            }, timer);
        }

        get showLineAnimate() {
            return this.$store.state.shape.lineAnimateData.showAnime;
        }

        get customPreferContent() {
            return this.$store.state.ui.customPreferContent;
        }
        set customPreferContent(v) {
            this.$store.commit("setStatus", {
                type: "customPreferContent",
                data: v,
            });
        }
        get paletteShowAlpha() {
            return this.$store.state.ui.paletteShowAlpha;
        }
        get couldFix() {
            if (this.force) return false;
            return this.$store.state.ui.couldFixWindow;
        }
        set couldFix(v) {
            this.$store.commit("setStatus", {
                type: "couldFixWindow",
                data: v,
            });
        }
        toFix() {
            this.$track("fixedbutton", "clickfixedbutton", `source: ${this.type}`);
            this.$store.commit("setStatus", {
                type: this.type + "Window",
                data: true,
            });
            this.showPalette = false;

            this.$store.commit("setStatus", {
                type: "couldFixWindow",
                data: false,
            });
            this.$bus.$emit("updateColorLock", {
                type: this.type,
                status: true,
            });
        }

        toCloseFix() {
            this.$store.commit("setStatus", {
                type: this.type + "Window",
                data: false,
            });
            this.showPalette = true;
            this.$store.commit("toPalette", { type: null });
            this.$bus.$emit("updateColorLock", {
                type: this.type,
                status: false,
            });
        }

        startDrag(e: MouseEvent) {
            if (!this.fixed) return;
            let x = e.clientX;
            let y = e.clientY;
            let left = this.fixLeft;
            let top = this.fixTop;
            document.onmousemove = (e) => {
                this.fixLeft = left + e.clientX - x;
                this.fixTop = top + e.clientY - y;
            };
            document.onmouseup = () => {
                this.$bus.$emit("updateColorPos", {
                    type: this.type,
                    left: this.fixLeft,
                    top: this.fixTop,
                });
                document.onmousemove = null;
            };
        }

        showFixTips = false;
        fixTipsDom = null;
        useFixTips = true;
        checkFixTips() {
            // 检查是否需要弹出提示
            let key = this.type;
            let checkLocal = () => {
                let showfix = localStorage.getItem("showfixTips") || "";
                let lastfix = localStorage.getItem("lastfixTips") || "";
                if (!!showfix) {
                    return false;
                } else if (lastfix == key) {
                    localStorage.setItem("showfixTips", "1");
                    return true;
                } else if (lastfix != key) {
                    localStorage.setItem("lastfixTips", key);
                    return false;
                }
            };
            if (checkLocal()) {
                let dom = this.$refs.fixBtn as HTMLElement;
                this.fixTipsDom = dom;
                this.showFixTips = true;
            }
        }
        closeFixTips() {
            this.useFixTips = false;
        }

        clickData = null;

        /**
         * 改颜色
         */
        clickColor(e, color: string, col: number, row: number) {
            let view = window["_view"];
            // if(this.paletteType === 'fillColor'){ //工具条 则先设置为纯色
            //     view.setFmt({},eFmtSetFlag.ColorSolid | this.fmtType.fill, false);
            // }else if(this.paletteType === 'lineColor'){
            //     view.setFmt({},eFmtSetFlag.ColorSolid | this.fmtType.line, false);
            // }
            let colors = this.recentColors;
            let isInRecent = colors.indexOf(color);
            if (isInRecent !== -1) {
                colors.splice(isInRecent, 1);
            }
            colors.unshift(color);
            this.recentClickColors = colors; // 触发 set 函数
            if (this.fromPlugin) {
                this.$emit("setColor", color);
                return;
            }
            if (this.isEchartBgColor) {
                this.$bus.$emit("setEchartBgColor", color);
                return;
            }
            if (this.fromRightPanelColor) {
                this.sensors.track("styleSet", {
                    Catalogues: "rightMenu Bar",
                    style_tab: this.type === "RightColorLine" ? "line" : this.type === "RightColorFill" ? "fill" : "shadow",
                });
            }
            if (this.colorType === this.fmtType.font) {
                if (this.type === "fontColor") {
                    if (this.windowType == "fontColor") {
                        this.trackFontColor("fontColor");
                    }
                    if (!this.fixed) {
                        this.closeThis();
                    }
                    if (window["_view"]._activeShape instanceof EDChart) {
                        let state = this.$store.state.echart;
                        window["_view"].processChartCMD("labelFontColor", {
                            index: state.index,
                            data: color,
                        });
                        return;
                    } else if (this.$store.state.shape.type == "EChartItem") {
                        this.$bus.$emit("setEditEchartData", {
                            textStyle: {
                                color,
                            },
                            label: {
                                color,
                            },
                            legend: {
                                textStyle: {
                                    color,
                                },
                            },
                        });
                        return;
                    }
                }
                this.trackRightMenuStyleTextSet();
                if (this.$store.state.dialog.showDialog && this.$store.state.dialog.dialogType === "note") {
                    let ts = this as any;
                    ts.$bus.$emit("modNoteColor");
                }
                if (this.colorIndex) {
                    view.editStyle("backgroundColor", color);
                    this.$store.commit("setFontFmtData", {
                        type: "backClr",
                        data: color,
                    });
                    if (this.windowType == "fontbgColor") {
                        this.trackFontColor("fontBgColor");
                    }
                    this.clickData = {
                        type: "backgroundColor",
                        value: color,
                    };
                } else {
                    let tint: number;
                    let themeIndex: number;

                    if (col === void 0 && row === void 0) {
                        tint = 0;
                        themeIndex = 0;
                    } else {
                        color = this.themeColor[col][0];
                        tint = this.themetints[col][row];
                        themeIndex = col + 1;
                    }
                    let payload = {
                        _color: color,
                        _tint: tint,
                        _themeIndex: themeIndex,
                        _alpha: parseFloat((1 - this.alphaVal / 100).toFixed(2)),
                    };
                    this.clickData = {
                        type: "fontColor",
                        value: color,
                    };
                    if (this.activeFloatItem != -1 && this.$store.state.dialog.showDialog && this.$store.state.dialog.dialogType === "note") {
                        // note dialog not activeShape click color
                        view.editStyle("fontColor", payload);
                    } else if (this.isSelect) {
                        view.editStyle("fontColor", payload);
                    } else {
                        this.$bus.$emit("changePageFont", {
                            type: "color",
                            data: color,
                        });
                    }
                    if (this.windowType == "fontColor") {
                        this.trackFontColor("fontColor");
                    }
                }
                if (this.$store.state.dialog.showDialog && this.$store.state.dialog.dialogType === "note") {
                    this.$nextTick(() => {
                        document.getElementById("edNoteEditDiv").focus();
                    });
                }
                if (this.type === "themeTextColor") {
                    this.$bus.$emit("changeThemeFontColor", color);
                }
            } else if (
                (this.colorType <= this.fmtType.shadow && this.colorType >= this.fmtType.fill) ||
                this.colorType === this.fmtType.mmFill ||
                this.colorType === this.fmtType.mmLine
            ) {
                let tint: number;
                let themeIndex: number;

                if (col === void 0 && row === void 0) {
                    tint = 0;
                    themeIndex = 0;
                } else {
                    color = this.themeColor[col][0];
                    tint = this.themetints[col][row];
                    themeIndex = col + 1;
                }
                let payload = {
                    _paintType: this.currentPaintType,
                    _index: this.colorIndex,
                    _color: color,
                    _tint: tint,
                    _alpha: 1,
                    _themeIndex: themeIndex,
                };
                let colorType = this.colorType;
                if (colorType === this.fmtType.mmFill) colorType = this.fmtType.fill;
                else if (colorType === this.fmtType.mmLine) colorType = this.fmtType.line;
                if (this.$store.state.ui.layoutChildIdx >= 0) {
                    let idx = this.$store.state.ui.layoutChildIdx;
                    window["_view"].setSmartFillStyle(payload, eFmtSetFlag.ColorModify | colorType, idx);
                } else if (this.$store.state.ui.specialColorIndex >= 0) {
                    view.setSpecialClr(payload, eFmtSetFlag.ColorModify | colorType, this.$store.state.ui.specialColorIndex);
                    this.$store.commit("setStatus", {
                        type: "specialColorIndex",
                        data: -1,
                    });
                } else if (this.type == "ReplaceColor" || this.type == "ReplaceFillWithLine") {
                    let fromClr = [];
                    if (this.colorType == this.fmtType.fill) {
                        for (let i = 0; i < this.$store.state.ui.replaceFillCheck.length; i++) {
                            if (this.$store.state.ui.replaceFillCheck[i]) fromClr.push(this.$store.state.ui.pageItemFillClr[i]);
                        }
                    } else {
                        for (let i = 0; i < this.$store.state.ui.replaceLineCheck.length; i++) {
                            if (this.$store.state.ui.replaceLineCheck[i]) fromClr.push(this.$store.state.ui.pageItemLineClr[i]);
                        }
                    }
                    view.replaceSimilarColorPreview2(
                        fromClr,
                        payload,
                        this.colorType == this.fmtType.fill,
                        this.type == "ReplaceFillWithLine" ? true : false
                    );
                } else {
                    view.setFmt(payload, eFmtSetFlag.ColorModify | colorType, undefined, this.type);
                }
            } else if (this.colorType === this.fmtType.background) {
                // 页面背景色
                // if (!this.vip) {
                //     this.$checkAuth({
                //         type: "pageBackgroundColor",
                //         buyTrigger: "setBackgroundPop",
                //     });
                // } else {
                view.setPageBackgroundColor(color);
                if (!this.vip && color != "#ffffff") {
                    this.sensors.track("tryVipBenefit", {
                        Catalogues: "editFileProcess",
                        trial_vip_benefit: "setBackgroundPop",
                    });
                }
                this.$store.commit("setPageStat", {
                    type: "pageBackgroundColor",
                    data: color,
                });
                // }
            } else if (this.colorType === this.fmtType.table) {
                if (this.colorIndex < 3) {
                    // 右侧栏修改颜色
                    let colorList = this.$store.state.table.tableFillColor;
                    let state = this.$store.state.table.tableFill;
                    let payload = {
                        _paintType: 1,
                        _index: 0,
                        _color: color,
                        _tint: 0,
                        _themeIndex: 0,
                    };
                    let mixpayload = {
                        // 第一种颜色
                        _paintType: 1,
                        _index: 0,
                        _color: colorList[1],
                        _tint: 0,
                        _themeIndex: 0,
                    };
                    let mixpayload2 = {
                        // 第二种颜色
                        _paintType: 1,
                        _index: 0,
                        _color: colorList[2],
                        _tint: 0,
                        _themeIndex: 0,
                    };
                    if (this.colorIndex == 0) {
                        if (state[0]) {
                            view.setTableFillPre();
                            view.setFillRowClr(payload, eFmtSetFlag.ColorModify | this.fmtType.fill, state[0]);
                            view.invalidate();
                        }
                        this.$store.commit("setTableFillColor", { type: "top", data: color });
                        this.closeThis();
                        return;
                    }
                    let num = 0;
                    if (state[1]) num += 2;
                    if (state[2]) num += 1;

                    num && view.setTableFillPre();
                    switch (num) {
                        case 1: {
                            // 列
                            let isleft = this.colorIndex == 1 ? true : false;
                            view.setFillColClr(payload, eFmtSetFlag.ColorModify | this.fmtType.fill, state[0], isleft);
                            break;
                        }
                        case 2: {
                            // 行
                            view.setFillRowClr(payload, eFmtSetFlag.ColorModify | this.fmtType.fill, state[0], this.colorIndex);
                            break;
                        }
                        case 3: {
                            // 行列
                            let Firstcolor = this.colorIndex == 1 ? mixpayload2 : payload;
                            let Secondcolor = this.colorIndex == 1 ? payload : mixpayload;
                            view.setFillRowClr(Firstcolor, eFmtSetFlag.ColorModify | this.fmtType.fill, state[0], 2);
                            view.setFillColClr(Firstcolor, eFmtSetFlag.ColorModify | this.fmtType.fill, state[0], false);
                            view.setFillRowClr(Secondcolor, eFmtSetFlag.ColorModify | this.fmtType.fill, state[0], 1);
                            view.setFillColClr(Secondcolor, eFmtSetFlag.ColorModify | this.fmtType.fill, state[0]);
                            break;
                        }
                    }
                    this.$store.commit("setTableFillColor", {
                        type: `row${this.colorIndex}`,
                        data: color,
                    });
                    num && view.invalidate();
                } else {
                    // 插入表格修改颜色
                    let colorList = this.$store.state.table.createTableFillColor;
                    let state = this.$store.state.table.createTableFill;
                    let payload = {
                        _index: 0,
                        _color: color,
                    };
                    let mixpayload = {
                        // 第一种颜色
                        _index: 0,
                        _color: colorList[1],
                    };
                    let mixpayload2 = {
                        // 第二种颜色
                        _index: 0,
                        _color: colorList[2],
                    };
                    if (this.colorIndex == 10) {
                        this.$store.commit("setTableFillColor", {
                            type: "top",
                            data: color,
                            target: "create",
                        });
                        this.closeThis();
                        return;
                    }
                    let num = 0;
                    let index = this.colorIndex - 10;
                    this.$store.commit("setTableFillColor", {
                        type: `row${index}`,
                        data: color,
                        target: "create",
                    });
                }
            } else if (this.colorType === this.fmtType.echart) {
                this.changeEChartColor(color);
            } else if (this.colorType === this.fmtType.imageSet) {
                window["_view"].setImageRecolor(color);
            } else if (this.colorType === this.fmtType.OnceColor) {
                this.$store.commit("setStatus", {
                    type: "onceColor",
                    data: color,
                });
            } else if (this.colorType === this.fmtType.themeColor) {
                let colorList = this.$store.state.ui.themeColorList.slice();
                colorList[this.colorIndex] = color;
                this.$store.commit("setStatus", {
                    type: "themeColorList",
                    data: colorList,
                });
                this.$bus.$emit("themeColorListChanged");
            } else if (this.colorType === this.fmtType.defaultFont) {
                this.$store.commit("setStatus", {
                    type: "customDefaultFontColor",
                    data: color,
                });
            } else if (this.colorType === this.fmtType.defaultFontbg) {
                this.$store.commit("setStatus", {
                    type: "customDefaultFontColorBg",
                    data: color,
                });
            } else if (this.colorType === this.fmtType.branchFill) {
                this.$store.commit("setMindMasterState", {
                    type: "branchFillColor",
                    data: color,
                });
                view.setBranchFillColor(new EDColor(color));
                this.sensors.track("editMindMap", {
                    Catalogues: "shortcutToolbar",
                    content: "setMMBranchFillColor",
                });
            } else if (this.colorType === this.fmtType.branchLine) {
                this.$store.commit("setMindMasterState", {
                    type: "branchLineColor",
                    data: color,
                });
                view.setBranchLineColor(new EDColor(color));
                this.sensors.track("editMindMap", {
                    Catalogues: "shortcutToolbar",
                    content: "setMMBranchLineColor",
                });
            } else if (this.colorType === this.fmtType.mathColor) {
                this.$bus.$emit("mathColorSet", color);
                this.$bus.$emit("focusMathEditor");
            } else if (this.colorType == this.fmtType.connector) {
                this.$bus.$emit("changeThemeLineColor", color);
            } else if (this.colorType === this.fmtType.lineAnimate) {
                if (!this.vip) {
                    const count = view.getAnimationCount();
                    if (count === 2 && !this.showLineAnimate) {
                        if (this.type === "lineAnimateFloatTool" || this.type === "lineAnimateNavigation") {
                            this.$bus.$emit("showLineFunVipTipFloatTool", "lineAnimationLimitCount");
                        } else if (this.type === "lineAnimateRigthPanel") {
                        }
                        this.changeClickPropagation(e);
                        if (!this.fixed) {
                            this.closeThis();
                        }
                        return;
                    }
                }
                if (this.type === "lineAnimateFloatTool") {
                    this.sensors.track("editConnector", {
                        Catalogues: "shortcutToolbar",
                        content: "clickFlowAnimitionl",
                    });
                } else if (this.type === "lineAnimateNavigation") {
                    this.sensors.track("clickEditPageButton", {
                        Catalogues: "editPageButton",
                        button_type: "clickFlowAnimitionl",
                    });
                } else if (this.type === "lineAnimateRigthPanel") {
                    this.sensors.track("styleSet", {
                        Catalogues: "rightMenu Bar",
                        style_tab: "flowAnimitionl",
                    });
                }
                this.$store.commit("setLineAnimateData", {
                    type: "animeColor",
                    data: color,
                });
                if (!this.showLineAnimate) {
                    this.$bus.$emit("changePageConnectLineAnimation", {
                        type: "animeColor",
                        data: color,
                    });
                } else {
                    view.animeOperation(4, color);
                }
            }
            this.changeClickPropagation(e);
            if (!this.fixed) {
                this.closeThis();
            }
        }

        changeEChartColor(data: string) {
            let color = new EDColor();
            color.fromString(data, false);
            let newAlpah = parseFloat((1 - this.alphaVal / 100).toFixed(2));
            color._alpha = newAlpah;
            color = color.toString(false);
            if (this.$store.state.shape.type == "EChartItem") {
                let type = this.$store.state.newEchart.activeChartType;
                let num = this.colorIndex;
                let page = 0;
                const option = JSON.parse(this.$store.state.newEchart.activeChartOption);
                if (this.type === "scatter01ItemColor") {
                    this.$bus.$emit("setScatter01ItemColor", color);
                } else if (this.type === "bar09ItemColor") {
                    this.$bus.$emit("setBar09ItemColor", color);
                } else if (this.type === "sankeyItemColor") {
                    this.$bus.$emit("setSankeyItemColor", color);
                } else if (this.colorIndex == 666) {
                    // 特殊：修改二维坐标轴颜色
                    this.$bus.$emit("setEditEchartData", "coordinateColor", { index: num, color: color });
                } else if (this.colorIndex == 667) {
                    this.$bus.$emit("changeAxisColor", color);
                } else if (this.colorIndex == 668) {
                    this.$bus.$emit("changeAxisSplitColor", color);
                } else if (this.colorIndex == 669) {
                    this.$bus.$emit("changeAxisFontColor", color);
                } else if (["bar", "waterfall", "line", "scatter", "boxplot"].includes(type)) {
                    this.$bus.$emit("changeSeriesColor", { index: num - 1, color: color });
                } else if (type == "radar") {
                    this.$bus.$emit("setEchartRadarColor", color);
                    // window["_view"].processChartCMD("overallColor", {
                    //     index: num,
                    //     data: color,
                    //     page: page,
                    // });
                } else if (["pie", "candlestick", "parallel", "graph", "linebar"].includes(type)) {
                    this.$bus.$emit("changeSeriesColor", { index: num, color: color });
                } else if (type == "funnel") {
                    this.$bus.$emit("setEchartFunnelColor", { index: num, color: color });
                } else if (type == "sankey") {
                    this.$bus.$emit("setEchartSankeyColor", color);
                } else if (type == "sunburst") {
                    this.$bus.$emit("setEchartSunburstColor", color);
                } else if (type == "scatter" || type == "bubble") {
                    window["_view"].processChartCMD("overallColor", {
                        index: num,
                        data: color,
                        page: page,
                    });
                } else if (type == "gauge") {
                    let arr = JSON.parse(JSON.stringify(this.$store.state.echart.gaugeRangeArr));
                    arr[num][1] = color;

                    window["_view"].processChartCMD("gaugeSector", { data: arr, page: page });
                    this.$store.commit("setEChartState", { type: "gaugeRangeArr", data: arr });
                } else if (type == "map") {
                    if (this.colorIndex == 2) {
                        window["_view"].processChartCMD("visualMapHightColor", { data: color });
                        this.$store.commit("setEChartState", {
                            type: "visualMapHightColor",
                            data: color,
                        });
                    } else if (this.colorIndex == 3) {
                        window["_view"].processChartCMD("visualMapLowColor", { data: color });
                        this.$store.commit("setEChartState", {
                            type: "visualMapLowColor",
                            data: color,
                        });
                    } else if (this.colorIndex == 1) {
                        window["_view"].processChartCMD("mapAreaColor", { data: color });
                        this.$store.commit("setEChartState", {
                            type: "mapBackground",
                            data: color,
                        });
                    } else if (this.colorIndex == 4) {
                        window["_view"].processChartCMD("mapLineColor", { data: color });
                        this.$store.commit("setEChartState", { type: "mapLineColor", data: color });
                    } else if (this.colorIndex >= 500) {
                        // map 分段颜色
                        let arr = JSON.parse(JSON.stringify(this.$store.state.echart.mapColorData));
                        arr[num - 500][1] = color;

                        let upData = [];
                        for (let i = 0; i < arr.length; i++) {
                            let obj = {
                                min: i == arr.length - 1 ? 0 : arr[i + 1][0],
                                max: arr[i][0],
                                color: arr[i][1],
                            };
                            upData.push(obj);
                        }
                        window["_view"].processChartCMD("visualMapPieces", {
                            data: upData,
                            page: page,
                        });
                        this.$store.commit("setEChartState", { type: "mapColorData", data: arr });
                    }
                }
                this.$store.commit("setEChartState", { type: "changeColor", data: color });
            } else {
                let type = this.$store.state.echart.chartType;
                let num = this.colorIndex;
                let page = 1;
                if (!this.$store.state.ui.isEChartData) {
                    page = 0;
                }
                if (this.colorIndex == 666) {
                    // 特殊：修改二维坐标轴颜色
                    window["_view"].processChartCMD("axisLineColor", {
                        index: "xy",
                        data: color,
                        page: page,
                    });
                    this.$store.commit("setEChartState", { type: "coordinateColor", data: color });
                } else if (type == "bar") {
                    window["_view"].processChartCMD("overallColor", {
                        index: num,
                        data: color,
                        page: page,
                    });
                } else if (type == "line") {
                    window["_view"].processChartCMD("overallColor", {
                        index: num,
                        data: color,
                        page: page,
                    });
                } else if (type == "radar") {
                    window["_view"].processChartCMD("overallColor", {
                        index: num,
                        data: color,
                        page: page,
                    });
                } else if (type == "pie" || type == "funnel") {
                    let pieList = this.$store.state.echart.pieList;
                    let arr = [];
                    for (let i = 0; i < pieList.length; i++) {
                        arr.push(pieList[i].color);
                    }
                    arr.splice(num, 1, color);
                    let temp = JSON.parse(JSON.stringify(pieList[num]));
                    temp.color = color;
                    pieList.splice(num, 1, temp);
                    window["_view"].processChartCMD("sectorColors", { data: arr, page: page });
                    this.$store.commit("setEChartState", {
                        type: "lineAreaFilledColor",
                        data: pieList,
                    });
                } else if (type == "scatter" || type == "bubble") {
                    window["_view"].processChartCMD("overallColor", {
                        index: num,
                        data: color,
                        page: page,
                    });
                } else if (type == "gauge") {
                    let arr = JSON.parse(JSON.stringify(this.$store.state.echart.gaugeRangeArr));
                    arr[num][1] = color;

                    window["_view"].processChartCMD("gaugeSector", { data: arr, page: page });
                    this.$store.commit("setEChartState", { type: "gaugeRangeArr", data: arr });
                } else if (type == "map") {
                    if (this.colorIndex == 2) {
                        window["_view"].processChartCMD("visualMapHightColor", { data: color });
                        this.$store.commit("setEChartState", {
                            type: "visualMapHightColor",
                            data: color,
                        });
                    } else if (this.colorIndex == 3) {
                        window["_view"].processChartCMD("visualMapLowColor", { data: color });
                        this.$store.commit("setEChartState", {
                            type: "visualMapLowColor",
                            data: color,
                        });
                    } else if (this.colorIndex == 1) {
                        window["_view"].processChartCMD("mapAreaColor", { data: color });
                        this.$store.commit("setEChartState", {
                            type: "mapBackground",
                            data: color,
                        });
                    } else if (this.colorIndex == 4) {
                        window["_view"].processChartCMD("mapLineColor", { data: color });
                        this.$store.commit("setEChartState", { type: "mapLineColor", data: color });
                    } else if (this.colorIndex >= 500) {
                        // map 分段颜色
                        let arr = JSON.parse(JSON.stringify(this.$store.state.echart.mapColorData));
                        arr[num - 500][1] = color;

                        let upData = [];
                        for (let i = 0; i < arr.length; i++) {
                            let obj = {
                                min: i == arr.length - 1 ? 0 : arr[i + 1][0],
                                max: arr[i][0],
                                color: arr[i][1],
                            };
                            upData.push(obj);
                        }
                        window["_view"].processChartCMD("visualMapPieces", {
                            data: upData,
                            page: page,
                        });
                        this.$store.commit("setEChartState", { type: "mapColorData", data: arr });
                    }
                }
                this.$store.commit("setEChartState", { type: "changeColor", data: color });
            }
        }

        /** 浮动菜单文本颜色埋点 */
        get commonTrackFlagFontColor() {
            return this.$store.state.floatTool.commonTrackFlag.fontColor;
        }
        get commonTrackFlagFontBgColor() {
            return this.$store.state.floatTool.commonTrackFlag.fontBgColor;
        }

        trackRightMenuStyleTextSet() {
            if (this.paletteInfo.rightPanel) {
                this.sensors.track("styleSet", {
                    Catalogues: "rightMenu Bar",
                    text_tab: "text",
                });
            }
        }
        trackFontColor(type) {
            if (this.fixed) return; // 排除专注模式下fixed颜色工具
            let storeOptions = {};
            switch (type) {
                case "fontColor":
                    if (this.commonTrackFlagFontColor) return;
                    Object.assign(storeOptions, { fontColor: 1 });
                    break;
                case "fontBgColor":
                    if (this.commonTrackFlagFontBgColor) return;
                    Object.assign(storeOptions, { fontBgColor: 1 });
                    break;
            }
            this.$store.commit("setCommonTrackFlag", storeOptions);
            this.sensors.track("commonTool", {
                Catalogues: "shortcutToolbar",
                content: type,
            });
        }
        get isStopPropagation() {
            return this.$store.state.ui.isStopPropagation;
        }
        set isStopPropagation(v) {
            this.$store.commit("setStatus", {
                type: "isStopPropagation",
                data: v,
            });
        }
        changeClickPropagation(e) {
            this.isStopPropagation && e?.stopPropagation();
        }
        closeThis(e?) {
            e && this.changeClickPropagation(e);
            this.isStopPropagation = false;
            // if (this.paletteInfo.lastType == "menuPic") {
            //         this.$store.commit("toPaletteLastType", this.paletteInfo.type);
            // } else {
            //         this.$store.commit("toPaletteLastType", "");
            // }
            if (this.fixed) return;
            this.endPreview();
            this.$store.commit("toPalette", { type: null, rightPanel: false });
            this.$store.commit("setStatus", {
                type: "showPalette",
                data: false,
            });
            this.$store.commit("setLayoutChild", { idx: -1 });

            this.$store.commit("setStatus", {
                type: "couldFixWindow",
                data: false,
            });
            this.$store.commit("setStatus", {
                type: "activeColorIndex",
                data: 0,
            });

            this.$store.commit("setStatus", {
                type: "paletteShowAlpha",
                data: true,
            });
        }
        // 预览
        startPreview(ptype, data) {
            let view = window["_view"];
            switch (ptype) {
                case "lineSize":
                    view.setlineFmtwidth(data, true);
                    break;
                case "lineType":
                    view.setlineFmtDash(data, true);
                    break;
                case "arrowType":
                    let { type, value } = data;
                    view.setLineAllArrow(value - 1, true, type);
                    break;
            }
        }
        endPreview() {
            window["_view"].hoverLeava();
        }

        get isLine() {
            return this.$store.state.shape.isLine;
        }
        mouseoverColor(e, color) {
            if (this.$store.state.dialog.showDialog && this.$store.state.dialog.dialogType === "note") {
                // note不需要预览颜色，预览时会刷新activeFloatItem导致编辑对象变更为activeshape
                return;
            }
            if (this.isEchartBgColor) {
                return;
            }
            let edcolor = new EDColor(color);
            let newAlpah = parseFloat((1 - this.alphaVal / 100).toFixed(2));
            edcolor._alpha = newAlpah;
            let view = window["_view"];
            if (this.colorType === this.fmtType.branchFill) {
                view.setBranchFillColor(edcolor, true);
            } else if (this.colorType === this.fmtType.branchLine) {
                view.setBranchLineColor(edcolor, true);
            } else if (this.colorType == this.fmtType.line || this.colorType == this.fmtType.mmLine) {
                if (this.type != "ReplaceColor" && this.type != "ReplaceFillWithLine") view.setlineFmtColor(edcolor, true);
            } else if (this.colorType == this.fmtType.fill || this.colorType == this.fmtType.mmFill) {
                if (this.type != "ReplaceColor" && this.type != "ReplaceFillWithLine") view.setFillFmtColor(edcolor, true);
            } else if (this.colorType == this.fmtType.font) {
                if (this.colorIndex == 0) {
                    // 文本
                    view.setFontPreviewFunc("fontColor", color);
                } else if (this.colorIndex == 1) {
                    // 文本背景
                    view.setFontPreviewFunc("fontBgColor", color);
                }
            } else if (this.colorType == this.fmtType.background) {
                view.setPageFillColor(edcolor, true);
            }

            if (this.windowType == "fontColor") {
                view.setFontPreviewFunc("fontColor", color);
            } else if (this.windowType == "fontbgColor") {
                view.setFontPreviewFunc("fontBgColor", color);
            }
        }
        mouseleaveColor() {
            if (this.$store.state.dialog.showDialog && this.$store.state.dialog.dialogType === "note") {
                // note不需要预览颜色，预览时会刷新activeFloatItem导致编辑对象变更为activeshape
                return;
            }
            if (this.isEchartBgColor) {
                return;
            }
            let c = this.colorType,
                list = [
                    this.fmtType.branchFill,
                    this.fmtType.branchLine,
                    this.fmtType.line,
                    this.fmtType.mmLine,
                    this.fmtType.fill,
                    this.fmtType.mmFill,
                    this.fmtType.font,
                    this.fmtType.background,
                ];
            const previewFont = this.windowType == "fontColor" || this.windowType == "fontbgColor";
            if (previewFont && this.clickData && window["_view"]._activeShape instanceof EDEChartItem) {
                this.clickData = null;
                return;
            }
            if (list.includes(c) || previewFont) {
                let view = window["_view"];
                view.hoverLeava();
            }
        }
        startPreviewNofill() {
            let view = window["_view"];
            if (this.colorType == this.fmtType.line || this.colorType == this.fmtType.mmLine) {
                if (this.type != "ReplaceColor" && this.type != "ReplaceFillWithLine") view.setlineFmtColor(0, true);
            } else if (this.colorType == this.fmtType.fill || this.colorType == this.fmtType.mmFill) {
                if (this.type != "ReplaceColor" && this.type != "ReplaceFillWithLine") view.setFillFmtColor(0, true);
            }

            if (this.windowType == "fontColor") {
                view.setFontPreviewFunc("fontColor", "transparent");
            } else if (this.windowType == "fontbgColor") {
                view.setFontPreviewFunc("fontBgColor", "transparent");
            }
        }
        endPreviewNofill() {
            this.endPreview();
        }
        // fillColor
        noFill() {
            // debugger
            if (this.isEchartBgColor) {
                this.$bus.$emit("setEchartBgColor", "transparent");
            } else if (this.type == "fontColor" || this.type == "fontbgColor") {
                window["_view"].editStyle("backgroundColor", "transparent");
                this.$store.commit("setFontFmtData", {
                    type: "backClr",
                    data: "transparent",
                });
            } else if (this.type == "defaultFontbg") {
                this.$store.commit("setStatus", {
                    type: "customDefaultFontColorBg",
                    data: "transparent",
                });
            } else if (this.$store.state.ui.specialColorIndex >= 0) {
                window["_view"].setSpecialClr({}, eFmtSetFlag.ColorNone | this.fmtType.fill, this.$store.state.ui.specialColorIndex);
                this.$store.commit("setStatus", {
                    type: "specialColorIndex",
                    data: -1,
                });
            } else if (this.colorType == this.fmtType.mmFill) {
                let colorType = this.fmtType.fill;
                let payload = {
                    _paintType: this.currentPaintType,
                    _index: this.colorIndex,
                    _color: this.currentColor,
                    _alpha: 0, // 设置透明度为0
                    _tint: undefined,
                    _themeIndex: undefined,
                };
                window["_view"].setFmt(payload, eFmtSetFlag.ColorModify | colorType, undefined, this.type);
            } else if (this.colorType === this.fmtType.branchFill) {
                let colorStr = "transparent";
                this.$store.commit("setMindMasterState", {
                    type: "branchFillColor",
                    data: colorStr,
                });
                window["_view"].setBranchFillColor(new EDColor(0, 0, 0, 0));
            } else window["_view"].setFmt({}, eFmtSetFlag.ColorNone | this.fmtType.fill);
            this.closeThis();
        }

        get expandStyleList() {
            return this.$store.state.ui.expandStyleList;
        }
        get isSdk() {
            return window["EDCONFIG"].IS_SDK;
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        moreColorSetting() {
            if (this.isSdk) {
                if (this.userInfo && this.userInfo.user_id !== 1) {
                    this.$bus.$emit("sdkToOnline", "quicktools");
                } else {
                    this.sdkApp.promisePostMessage("GOTO_LOGIN", "quicktools");
                }
            } else {
                let ts: any = this;
                this.expandRightPanelByKey("shapeP");
                this.$store.commit("setStatus", {
                    type: "newActiveType",
                    data: this.fmtType.styleSet,
                });
                this.$nextTick(() => {
                    this.$bus.$emit("rightStylePanelScrollTo", "fill");
                });
            }
            this.closeThis();
        }
        // lineColor
        activeDashTypeUrl(index) {
            return "dt" + index;
        }
        activeBeginTypeUrl(index) {
            return "arrow-" + index;
        }
        activeEndTypeUrl(index) {
            return "arrow-" + index;
        }
        selectLineSize(index, data) {
            let view = window["_view"];
            view.setFmt(
                {
                    _width: data,
                },
                eFmtSetFlag.LineWidth
            );
            this.closeThis();
            this.closeExtraList();
        }
        selectLineStyle(index) {
            let view = window["_view"];
            index = index == 1 ? index - 1 : index;
            view.setFmt(
                {
                    _dash: index,
                },
                eFmtSetFlag.LineDash
            );
            this.closeThis();
            this.closeExtraList();
        }
        selectRadius(id) {
            let view = window["_view"];
            let rsize;
            if (id <= 6) {
                rsize = id;
            } else if (id == 7) {
                rsize = 8;
            }
            this.RSize = rsize;
            view.setFmt(
                {
                    _round: rsize,
                },
                eFmtSetFlag.LineRound
            );
            this.closeThis();
            this.closeExtraList();
        }
        selectArrowL(index) {
            let view = window["_view"];
            view.setFmt(
                {
                    _type: index - 1,
                },
                eFmtSetFlag.LineBAType
            );
            this.closeThis();
            this.closeExtraList();
        }
        selectArrowR(index) {
            let view = window["_view"];
            view.setFmt(
                {
                    _type: index - 1,
                },
                eFmtSetFlag.LineEAType
            );
            this.closeThis();
            this.closeExtraList();
        }

        moreLineSetting() {
            if (this.isSdk) {
                if (this.userInfo && this.userInfo.user_id !== 1) {
                    this.$bus.$emit("sdkToOnline", "quicktools");
                } else {
                    this.sdkApp.promisePostMessage("GOTO_LOGIN", "quicktools");
                }
            } else {
                let ts: any = this;
                this.expandRightPanelByKey("shapeP");
                this.$store.commit("setStatus", {
                    type: "newActiveType",
                    data: this.fmtType.styleSet,
                });
                this.$nextTick(() => {
                    this.$bus.$emit("rightStylePanelScrollTo", "line");
                });
            }
            this.closeThis();
        }
        noLine() {
            let view = window["_view"];
            if (this.colorType === this.fmtType.branchLine) {
                let colorStr = "transparent";
                this.$store.commit("setMindMasterState", {
                    type: "branchLineColor",
                    data: colorStr,
                });
                view.setBranchLineColor(new EDColor(0, 0, 0, 0));
            } else if (this.colorType === this.fmtType.mmLine) {
                // view.setlineFmtColor(new EDColor(0,0,0,0));
                let colorType = this.fmtType.line;
                let payload = {
                    _paintType: this.currentPaintType,
                    _index: this.colorIndex,
                    _color: this.currentColor,
                    _alpha: 0, // 设置透明度为0
                    _tint: undefined,
                    _themeIndex: undefined,
                };
                window["_view"].setFmt(payload, eFmtSetFlag.ColorModify | colorType, undefined, this.type);
            } else {
                view.setFmt({}, eFmtSetFlag.ColorNone | this.fmtType.line);
            }
            this.closeThis();
        }
        // 思维导图分支线条设置
        selectBranchItem(type, data, preview: boolean = false) {
            let view = window["_view"];
            view._tool.endEdit();
            switch (type) {
                case "lineWidth":
                    // this.branchLineWidth = id + 1;
                    view.setBranchLineWidth(data.height, preview);
                    break;
                case "dottedLine":
                    // this.branchDottedLineActive = id;
                    view.setBranchLineDash(data.lineType, preview);
                    break;
                case "branchArrow":
                    // this.branchArrowActive = id;
                    view.setBranchLineArrow(data.arrowType, preview);
                    break;
                case "branchThickness":
                    // this.branchThicknessActive = id;
                    view.setBranchThickness(data.thickness, preview);
                    break;
                default:
                    break;
            }
            if (!preview) {
                this.closeExtraList();
            }
        }
        cancelPreview() {
            window["_view"].hoverLeava();
        }
        // 底部超出边界调整
        adjustPosition(type) {
            this.activeExtra = type;
            this.$nextTick(() => {
                let dom = this.$refs[`${type}List`] as HTMLElement;
                dom.style.top = "0px";
                let rect = dom.getBoundingClientRect() as DOMRect;
                let offsetHeight = window.innerHeight - (rect.y + rect.height);
                if (offsetHeight < 0) {
                    // top为负值
                    dom.style.top = offsetHeight + "px";
                }
            });
        }
        closeExtraList() {
            this.activeExtra = "";
        }

        get RSize() {
            return this.$store.state.shape.lineFmt.round;
        }
        set RSize(v) {
            let payload = {
                type: "round",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }
        get activeRPType() {
            if (this.RSize <= 6) {
                return parseInt(this.RSize);
            } else if (this.RSize === 8) {
                return 7;
            }
            return null;
        }
        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        get showPalette() {
            return this.force || this.$store.state.ui.showPalette;
        }
        set showPalette(v) {
            this.$store.commit("setStatus", {
                type: "showPalette",
                data: v,
            });
        }
        @Watch("type")
        watchShowPalette(nv, ov) {
            if (nv && nv != ov && this.$store.state.ui.showPalette) {
                this.$nextTick(() => {
                    this.checkFixTips();
                });
            }
        }

        get type() {
            if (this.fixed || this.force) {
                return this.windowType;
            }
            return this.paletteInfo.type;
        }
        get paletteInfo() {
            return this.$store.state.ui.paletteInfo;
        }
        get currentPaintType() {
            let paintType: number;
            let newType: number;
            if (this.colorType === null || this.colorType === void 0) {
                return null;
            } else if (this.colorType === this.fmtType.fill || this.colorType === this.fmtType.mmFill) {
                paintType = this.$store.state.shape.fillFmt.type;
            } else if (this.colorType === this.fmtType.line || this.colorType === this.fmtType.mmLine) {
                paintType = this.$store.state.shape.lineFmt.type;
            } else {
                return null;
            }
            if (paintType !== undefined) {
                if (paintType === 1) {
                    return 1;
                } else if (paintType > 1 && paintType < 5) {
                    return 2;
                } else if (paintType === 6) {
                    return 3;
                } else {
                    return null;
                }
            }
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get showNoFill() {
            let type = this.$store.state.shape.type;
            if (type) {
                if (type.indexOf("Swim") >= 0 && this.$store.state.ui.specialColorIndex == 0) return false;
            }
            return true;
        }
        toggleTypeEvt(e) {
            if (e.keyCode === 9) {
                e.preventDefault();
                e.stopPropagation();
                this.showType = Number(!this.showType);
            }
        }
        @Watch("type")
        onPalTypeChanged(val: string) {
            let binded = false;
            if (val === "ChildFillColorQuick") {
                this.showType = 1;
            } else {
                this.showType = 0;
            }
            if (val && this.showPalette && val.startsWith("ChildFillColor")) {
                if (!binded) {
                    document.addEventListener("keydown", this.toggleTypeEvt, true);
                    binded = true;
                }
            } else {
                document.removeEventListener("keydown", this.toggleTypeEvt, true);
                binded = false;
            }
            if (this.type !== "") {
                this.$nextTick(() => {
                    let ele = <HTMLElement>this.$refs.pal;
                    if (!ele) return;
                    ele.focus();
                    //当超出屏幕边界的时候，调整位置
                    if (ele.offsetLeft + ele.offsetWidth > document.documentElement.clientWidth) {
                        ele.style.right = "20px";
                        ele.style.left = "auto";
                    }
                });
            }
        }
        changeTyoe(showType) {
            this.showType = showType;
            if (!this.quickStyleIcons.length) {
                window["_view"].getQuickStyleList();
            }
        }
        get quickStyleIcons() {
            return this.$store.state.page.quickStyleImageMap;
        }
        get colorType() {
            if (this.fixed || this.force) {
                if (this.type === "fillColor") {
                    return this.fmtType.fill;
                } else if (this.type === "lineColor") {
                    return this.fmtType.line;
                } else if (this.type === "fontColor") {
                    return this.fmtType.font;
                } else if (this.type === "fontbgColor") {
                    return this.fmtType.font;
                } else if (this.type === "mapBgColor") {
                    return this.fmtType.echart;
                } else if (this.type === "branchFill") {
                    return this.fmtType.branchFill;
                } else if (this.type === "branchLine") {
                    return this.fmtType.branchLine;
                } else if (this.type == "ChildFillColor" || this.type == "ChildFillColorQuick") {
                    return this.fmtType.fill;
                } else if (this.type === "mmLine") {
                    return this.fmtType.mmLine;
                } else if (this.type === "mmFill") {
                    return this.fmtType.mmFill;
                } else if (this.type === "themeTextColor") {
                    return this.fmtType.font;
                } else if (this.type === "themeConnectorColor") {
                    return this.fmtType.connector;
                }
            }
            return this.$store.state.ui.activeColor;
        }

        tempData = null;

        modifyTintPreRedo() {
            if (!this.isSelect) return;
            this.tempData = this.alphaVal;
            window["_view"].addFormatPreUndoAct(this.from);
        }
        modifyTintRedo() {
            if (!this.isSelect) return;
            let flag = false;
            flag = this.tempData != this.alphaVal;
            window["_view"].addFormatUndoAct(flag);
            this.tempData = false;
            this.trackRightMenuStyleTextSet();
        }

        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                            this.trackRightMenuStyleTextSet();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }

        get isPicFill() {
            return this.$store.state.shape.fillFmt.type === 7;
        }
        get alphaVal() {
            if (this.isEchartBgColor) {
                if (this.isEmptyCurrentEchartBgColor) {
                    return 0;
                }
                const bgColor = new EDColor();
                bgColor.fromString(this.currentEchartBgColor, false);
                return Math.round((1 - bgColor.alpha()) * 100);
            }

            if (this.colorType === null) {
                return 0;
            } else if (this.colorType === this.fmtType.fill && this.$store.state.shape.fillFmt.alphas) {
                if (this.isPicFill) {
                    // 图片填充
                    return Math.round(((255 - this.$store.state.shape.fillFmt.textureAlpha) / 255) * 100);
                }
                return Math.round((1 - this.$store.state.shape.fillFmt.alphas[this.colorIndex]) * 100);
            } else if (this.colorType === this.fmtType.line && this.$store.state.shape.lineFmt.alphas) {
                return Math.round((1 - this.$store.state.shape.lineFmt.alphas[this.colorIndex]) * 100);
            } else if (this.colorType === this.fmtType.shadow) {
                return Math.round((1 - this.$store.state.shape.shadowFmt.alpha) * 100);
            } else if (this.colorType === this.fmtType.font && this.type !== "fontbgColor") {
                return Math.round((1 - this.$store.state.shape.fontFmt.alpha) * 100);
            } else if (this.colorType === this.fmtType.echart && !this.isEchartBgColor) {
                return Math.round((1 - this.$store.state.echart.activeSeriesColorAlpha) * 100);
            }

            return 0;
        }
        set alphaVal(v: any) {
            let payload = this.isPicFill
                ? {
                      type: "textureAlpha",
                      data: Math.round(255 - (v / 100) * 255),
                  }
                : {
                      type: "alphas",
                      data: 1 - v / 100,
                      index: this.colorIndex,
                  };

            if (this.isEchartBgColor) {
                // 设置图表背景颜色的透明度
                if (this.isEmptyCurrentEchartBgColor) {
                    return;
                }
                const bgColor = new EDColor();
                bgColor.fromString(this.currentEchartBgColor, false);
                if (Math.round(bgColor.alpha() * 100) / 100 === payload.data) {
                    return;
                }
                if (isNaN(payload.data)) {
                    return;
                }
                bgColor.setAlpha(payload.data);
                this.$bus.$emit("setEchartBgColor", bgColor.toString(false));
                return;
            }

            if (this.colorType === null) {
            } else if (this.colorType === this.fmtType.fill && this.$store.state.shape.fillFmt.alphas) {
                if (this.isPicFill) {
                    this.$store.commit("setFillFmtData", payload);
                } else {
                    this.$store.commit("setFillColorData", payload);
                }
            } else if (this.colorType === this.fmtType.line && this.$store.state.shape.lineFmt.alphas && !this.isPicFill) {
                this.$store.commit("setLineColorData", payload);
            } else if (this.colorType === this.fmtType.shadow) {
                payload.type = "alpha";
                this.$store.commit("setShadowFmtData", payload);
            } else if (this.colorType === this.fmtType.font) {
                //  设置文本字体色的透明度
                payload.type = "alpha";
                this.$store.commit("setFontFmtData", payload);
            } else if (this.colorType === this.fmtType.echart && !this.isEchartBgColor) {
                //  设置系列颜色的透明度
                payload.type = "activeSeriesColorAlpha";
                this.$store.commit("setEChartState", payload);
            }
        }

        get showAlpha() {
            let excludeWindowType = ["mmFill", "mmLine", "mapBgColor", "iconfont", "background", "themeTextColor", "themeConnectorColor"]; // 不显示的
            return (
                this.type !== "fontbgColor" &&
                this.type !== "background" &&
                !this.type?.includes("lineAnimate") &&
                !this.floatToolList.includes("onlyfontpath") &&
                this.paletteShowAlpha &&
                !excludeWindowType.includes(this.windowType) &&
                !this.fromRightPanelColor
            );
        }

        get alphaValDisabed() {
            return this.isEchartBgColor && this.isEmptyCurrentEchartBgColor;
        }

        get floatToolList() {
            return this.$store.state.floatTool.floatToolList;
        }

        get fromRightPanelColor() {
            return this.paletteInfo.type?.startsWith("RightColor");
        }

        get shapeType() {
            return this.$store.state.shape.type;
        }

        get currentSeriesColor() {
            return this.$store.state.echart.activeSeriesColor;
        }

        get currentEchartBgColor() {
            return this.$store.state.echart.activeBgColor;
        }

        get isEmptyCurrentEchartBgColor() {
            return ["", "transparent"].includes(this.currentEchartBgColor);
        }

        get isEchartBgColor() {
            return this.windowType === "echartBgColor";
        }

        changeAlpha() {
            if (!this.type || !this.showPalette || this.fromRightPanelColor) return;
            this.$nextTick(() => {
                let view = window["_view"];
                window["_view"]._tool.endEdit();
                if (isNaN(this.alphaVal)) return;
                let newAlpah = parseFloat((1 - this.alphaVal / 100).toFixed(2));
                if (this.colorType === this.fmtType.font) {
                    let len = this.fontColor.slice(1).length;
                    let payload = {
                        _color: len === 8 ? this.fontColor.slice(0, -2) : this.fontColor,
                        _tint: this.fontTint,
                        _themeIndex: this.fontIndex,
                        _alpha: newAlpah,
                    };
                    view.editStyle("fontColor", payload);
                    return;
                }

                if (this.colorType === this.fmtType.echart && this.type !== "mapBgColor" && this.type !== "echartBgColor") {
                    let color = this.currentSeriesColor;
                    this.changeEChartColor(color);
                    return;
                }
                if (this.shapeType === "EChartItem" || this.shapeType === "EDChart") {
                    // echartitem 、edchart 没有 fillColor  lineColor 的 paltte
                    return;
                }
                view.setFmt(
                    {
                        _paintType: 1,
                        _index: this.colorIndex,
                        _alpha: newAlpah,
                    },
                    eFmtSetFlag.ColorChangeAlpha | this.colorType,
                    false
                );
            });
        }

        get fontTint() {
            let tint = this.$store.state.shape.fontFmt.tint;
            if (this.isSelect) tint = this.$store.state.shape.fontFmt.tint;
            return 0;
        }
        get fontIndex() {
            let index = this.$store.state.shape.fontFmt.index;
            if (this.isSelect) index = this.$store.state.shape.fontFmt.index;
            return 0;
        }
        get fontColor() {
            let color = this.$store.state.shape.fontFmt.color;
            if (this.isSelect) color = this.$store.state.shape.fontFmt.color;
            else if (this.customSet && !this.ignoreDefFont) color = this.$store.state.ui.customDefaultFontColor;
            else color = this.$store.state.page.themeTextColor;
            if (color == null) {
                color = "#000";
            }
            return color;
        }

        get customSet() {
            return this.$store.state.ui.defaultFontType == 1;
        }
        get ignoreDefFont() {
            return this.$store.state.page.ignoreDefFont;
        }

        get colorIndex() {
            if (this.fixed) {
                return 0;
            }
            if (this.force && this.forceIndex != -1) {
                return this.forceIndex;
            }
            return this.$store.state.ui.activeColorIndex;
        }
        get theme() {
            return this.$store.getters.colorTheme;
        }
        get mmTheme() {
            return this.$store.getters.mmColorTheme;
        }
        get themetints() {
            let themeColor = this.theme;
            if (!themeColor) {
                // edraw flat
                return [
                    [0, -17, -31, -46, -57, -67, -76],
                    [0, 21, 14, 10, 6, 3, 1],
                    [0, 80, 60, 40, 20, -25, -50],
                    [0, 80, 60, 40, 20, -25, -50],
                    [0, 80, 60, 40, 20, -25, -50],
                    [0, 80, 60, 40, 20, -25, -50],
                    [0, 80, 60, 40, 20, -25, -50],
                    [0, 80, 60, 40, 20, -25, -50],
                    [0, 80, 60, 40, 20, -25, -50],
                    [0, 80, 60, 40, 20, -25, -50],
                ];
            }
            return themeColor._tints.slice(0, 10);
        }
        get themeColor() {
            let themeColor = this.theme;
            let mmthemeColor = this.mmTheme;
            if (this.colorType >= this.fmtType.branchFill && this.colorType <= this.fmtType.mmLine && mmthemeColor)
                return mmthemeColor._colors.slice(0, 10);
            if (!themeColor) {
                //edraw flat
                return [
                    ["#ffffff", "#ebebeb", "#d7d7d7", "#c2c2c2", "#afafaf", "#9b9b9b", "#868686"],
                    ["#000000", "#7e7e7e", "#696969", "#595959", "#454545", "#303030", "#191919"],
                    ["#96a6a6", "#eff1f1", "#dde1e1", "#c9d0d0", "#b2bcbc", "#839292", "#6d7979"],
                    ["#1bbc9d", "#e7f4f0", "#cce7df", "#abdacc", "#7eccb6", "#16a58a", "#118972"],
                    ["#3498db", "#e8eff8", "#cdddf1", "#aecaea", "#83b3e3", "#2d85c1", "#236ea1"],
                    ["#2da2bf", "#e8f0f4", "#cde0e8", "#adcedc", "#81bace", "#268ea8", "#1e768c"],
                    ["#ee7c31", "#fcece8", "#f8d7cd", "#f5bfad", "#f2a282", "#d26c2a", "#af5921"],
                    ["#ffaf00", "#fff2e7", "#ffe3cb", "#ffd4aa", "#ffc37c", "#e19a00", "#bc8000"],
                    ["#dd7195", "#f9ebef", "#f2d5dd", "#ebbbc8", "#e49cb1", "#c26383", "#a2516c"],
                    ["#527294", "#e9ebef", "#d0d5dc", "#b3bcc8", "#8d9cb1", "#476482", "#3a526b"],
                ];
            }
            return themeColor._colors.slice(0, 10);
        }
        get fillFmtType() {
            if (this.isEchartBgColor) return !this.isEmptyCurrentEchartBgColor;
            else if (this.colorType === this.fmtType.font && this.colorIndex) return this.$store.state.shape.fontFmt.backClr;
            else if (this.colorType === this.fmtType.defaultFontbg) return this.$store.state.ui.customDefaultFontColorBg != "transparent";
            else return this.$store.state.shape.fillFmt.type;
        }
        get lineFmtType() {
            return this.$store.state.shape.lineFmt.type;
        }
        get recentClickColors(): Array<string> {
            return this.recentColors;
        }
        get recentColorsLen(): number {
            return this.recentColors.length;
        }
        set recentClickColors(v: Array<string>) {
            if (v.length > 10) {
                v = v.slice(0, 10);
            }
            this.recentColors = v;
            localStorage.setItem("recentColors", JSON.stringify(v));
        }
        get isPageBg() {
            return this.$store.state.page.isPageBg;
        }
        get currentColor() {
            if (this.isEchartBgColor) {
                const bgColor = new EDColor();
                bgColor.fromString(this.currentEchartBgColor, false);
                bgColor.setAlpha(1);
                return bgColor.toString(false);
            }
            if (this.fromPlugin) {
                return this.pluginColor;
            }
            if (this.colorType == null || this.colorType == void 0) {
                return "#ffffff";
            } else if (this.colorType === this.fmtType.fill || this.colorType === this.fmtType.mmFill) {
                if (this.$store.state.ui.layoutChildIdx >= 0)
                    return this.$store.state.ui.layoutData.childData[this.$store.state.ui.layoutChildIdx - this.$store.state.ui.layoutData.childStart]
                        .color;
                else if (this.$store.state.ui.specialColorIndex >= 0)
                    return this.$store.state.shape.specialColor[this.$store.state.ui.specialColorIndex];
                else if (this.type == "ReplaceColor" || this.type == "ReplaceFillWithLine") return this.$store.state.ui.replaceFillColor;
                return (this.$store.state.shape.fillFmt.colors && this.$store.state.shape.fillFmt.colors[this.colorIndex]) || null;
            } else if (this.colorType === this.fmtType.line || this.colorType === this.fmtType.mmLine) {
                if (this.type == "ReplaceColor" || this.type == "ReplaceFillWithLine") return this.$store.state.ui.replaceLineColor;
                return (this.$store.state.shape.lineFmt.colors && this.$store.state.shape.lineFmt.colors[this.colorIndex]) || null;
            } else if (this.colorType === this.fmtType.shadow) {
                return this.$store.state.shape.shadowFmt.color || null;
            } else if (this.colorType === this.fmtType.font) {
                if (this.type === "themeTextColor") {
                    let textInfo = this.parseQueryString(this.$store.getters.textTheme.getTextEditInfo());
                    return textInfo._color;
                }
                if (this.colorIndex) {
                    return this.$store.state.shape.fontFmt.backClr;
                } else {
                    return this.$store.state.shape.fontFmt.color;
                }
            } else if (this.colorType === this.fmtType.background) {
                if (this.isPageBg) return this.$store.state.page.pageBackgroundColor;
                else return "";
            } else if (this.colorType === this.fmtType.echart) {
                if (this.colorIndex == 666) {
                    // 特殊：二维坐标轴颜色
                    return this.$store.state.echart.coordinateColor;
                } else if (this.$store.state.echart.chartType == "pie") {
                    return this.$store.state.echart.pieList?.[this.colorIndex]?.["color"];
                } else if (this.$store.state.echart.chartType == "map") {
                    if (this.colorIndex == 2) {
                        return this.$store.state.echart.visualMapHightColor;
                    } else if (this.colorIndex == 3) {
                        return this.$store.state.echart.visualMapLowColor;
                    } else if (this.colorIndex == 1) {
                        return this.$store.state.echart.mapBackground;
                    } else if (this.colorIndex == 4) {
                        return this.$store.state.echart.mapLineColor;
                    } else if (this.colorIndex >= 500) {
                        return this.$store.state.echart.mapColorData[this.colorIndex - 500][1];
                    }
                } else {
                    return this.$store.state.echart.chartDataColor[this.colorIndex];
                }
            } else if (this.colorType === this.fmtType.themeColor) {
                return this.$store.state.ui.themeColorList[this.colorIndex];
            } else if (this.colorType === this.fmtType.table) {
                if (this.colorIndex < 3) return this.$store.state.table.tableFillColor[this.colorIndex];
                else return this.$store.state.table.createTableFillColor[this.colorIndex - 10];
            } else if (this.colorType === this.fmtType.OnceColor) {
                return this.$store.state.ui.onceColor;
            } else if (this.colorType === this.fmtType.imageSet) {
                return this.$store.state.ui.pictureInfo.imgColor;
            } else if (this.colorType === this.fmtType.defaultFont) {
                return this.$store.state.ui.customDefaultFontColor;
            } else if (this.colorType === this.fmtType.defaultFontbg) {
                return this.$store.state.ui.customDefaultFontColorBg;
            } else if (this.colorType == this.fmtType.branchFill) {
                return this.$store.state.mindmaster.branchFillColor;
            } else if (this.colorType == this.fmtType.branchLine) {
                return this.$store.state.mindmaster.branchLineColor;
            } else if (this.colorType == this.fmtType.connector) {
                let connectorInfo = this.parseQueryString(this.$store.getters.connectorTheme.getLineEditInfo());
                return connectorInfo._color;
            } else if (this.colorType === this.fmtType.lineAnimate) {
                return this.$store.state.shape.lineAnimateData.animeColor;
            } else {
                return "#ffffff";
            }
        }
        get fromFloatTool() {
            return this.from == "floatTool";
        }
        get fromPlugin() {
            return this.from == "plugin";
        }
        get floatToolArrowList() {
            // type 箭头方向0 1 2对应 开始 结束，双向
            return [
                {
                    id: 0,
                    icon: "arrow-0",
                    type: 2,
                    value: 1,
                },
                {
                    id: 1,
                    icon: "arrow-3",
                    type: 0,
                    value: 4,
                },
                {
                    id: 2,
                    icon: "arrow-3",
                    type: 1,
                    value: 4,
                },
                // {
                //     id: 3,
                //     icon: 'mixarrow-3',
                //     type: 2,
                //     value: 4
                // },
                {
                    id: 4,
                    icon: "arrow-16",
                    type: 0,
                    value: 17,
                },
                {
                    id: 5,
                    icon: "arrow-16",
                    type: 1,
                    value: 17,
                },
                // {
                //     id: 6,
                //     icon: 'mixarrow-16',
                //     type: 2,
                //     value: 17
                // },
                {
                    id: 7,
                    icon: "arrow-4",
                    type: 0,
                    value: 5,
                },
                {
                    id: 8,
                    icon: "arrow-4",
                    type: 1,
                    value: 5,
                },
                // {
                //     id: 9,
                //     icon: 'mixarrow-4',
                //     type: 2,
                //     value: 3
                // },
                {
                    id: 10,
                    icon: "arrow-19",
                    type: 0,
                    value: 20,
                },
                {
                    id: 11,
                    icon: "arrow-19",
                    type: 1,
                    value: 20,
                },
                // {
                //     id: 12,
                //     icon: 'mixarrow-19',
                //     type: 2,
                //     value: 20
                // },
                {
                    id: 13,
                    icon: "arrow-8",
                    type: 0,
                    value: 9,
                },
                {
                    id: 14,
                    icon: "arrow-8",
                    type: 1,
                    value: 9,
                },
                {
                    id: 15,
                    icon: "arrow-9",
                    type: 0,
                    value: 10,
                },
                {
                    id: 16,
                    icon: "arrow-9",
                    type: 1,
                    value: 10,
                },
                {
                    id: 17,
                    icon: "arrow-22",
                    type: 0,
                    value: 23,
                },
                {
                    id: 18,
                    icon: "arrow-22",
                    type: 1,
                    value: 23,
                },
            ];
        }
        get activeFloatItem() {
            return this.$store.state.dialog.activeFloatItem;
        }

        selectFloatArrow(type, value) {
            if (type == 0) {
                this.selectArrowL(value);
                this.selectArrowR(1);
            } else if (type == 1) {
                this.selectArrowL(1);
                this.selectArrowR(value);
            } else if (type == 2) {
                this.selectArrowL(value);
                this.selectArrowR(value);
            }
        }

        parseQueryString(queryString) {
            const pairs = queryString.split("&");
            return pairs.reduce((acc, pair) => {
                const [key, value] = pair.split("=");
                acc[key] = value;
                return acc;
            }, {});
        }

        @Watch("currentColor")
        onColorChanged(val: string, oldVal: string) {
            if (val) {
                this.$store.commit("setStatus", {
                    type: "currentColor",
                    data: val,
                });
            }
        }

        mounted() {
            let colors = localStorage.getItem("recentColors");
            if (colors) {
                this.recentColors = JSON.parse(colors);
            } else {
                localStorage.setItem("recentColors", JSON.stringify([]));
                this.recentColors = [];
            }
            let ts = this as any;
            let sketchFuncName = "sketchOK";
            if (this.fixed || this.force) {
                sketchFuncName += this.type;
            }
            ts.$bus.$on(sketchFuncName, (e) => {
                //获取传递的参数并进行操作
                this.clickColor(undefined, e, undefined, undefined);
            });
        }
        beforeDestroy() {
            let sketchFuncName = "sketchOK";
            if (this.fixed || this.force) {
                sketchFuncName += this.type;
            }
            this.$bus.$off(sketchFuncName);
            this.$bus.$off("closeDefaultPalette");
            this.$bus.$off("setFixedPalettePos");
        }

        created() {
            if (this.fixed) {
                this.fixTop = this.paletteInfo.top;
                this.fixLeft = this.paletteInfo.left;
            }

            this.$bus.$on("closeDefaultPalette", () => {
                if (!this.fixed) {
                    this.showPalette = false;
                }
            });
            this.$bus.$on("setFixedPalettePos", (obj) => {
                if (obj.type == this.type) {
                    this.fixTop = obj.top;
                    this.fixLeft = obj.left;
                }
            });
        }
    }
</script>
